/**
 * Second internal approval on invoice page (when property config + amount threshold).
 */

const SECOND_SKIP_REASON_URGENCY = 'Hohe Dringlichkeit'

var INTERNAL_APPROVAL_API_ERROR_DE = {
  'ID parameter is missing': 'Technischer Fehler: Anfrage unvollständig.',
  Unauthorized: 'Nicht autorisiert.',
  'Invalid tier': 'Technischer Fehler.',
  'Invalid actionType': 'Technischer Fehler.',
  'Invoice not found': 'Rechnung nicht gefunden.',
  'Internal approval is not required.': 'Interne Freigabe ist nicht erforderlich.',
  'Approver contact is required': 'Freigeber erforderlich.',
  'Predefined approver cannot be changed.': 'Der vordefinierte Freigeber darf nicht geändert werden.',
  'First approval is required.': 'Erste Freigabe ist erforderlich.',
  'Contact not found': 'Kontakt nicht gefunden.',
  'Approver must differ from the previous approval.':
    'Der Freigeber muss sich von der vorherigen Freigabe unterscheiden.',
  'Contact is not an eligible approver.': 'Kontakt ist kein berechtigter Freigeber.',
  'Reason is required': 'Begründung erforderlich.',
  'Internal approval cannot be skipped.': 'Interne Freigabe kann nicht übersprungen werden.',
  'Internal approval was already skipped.': 'Interne Freigabe wurde bereits übersprungen.',
  'Failed to process internal approval': 'Interne Freigabe konnte nicht verarbeitet werden.',
}

function internalApprovalApiErrorToGerman(error) {
  if (!error) return 'Die Aktion konnte nicht ausgeführt werden.'
  return INTERNAL_APPROVAL_API_ERROR_DE[error] || 'Die Aktion konnte nicht ausgeführt werden.'
}

/**
 * Normalize contact id; treat 0 / invalid as empty.
 */
function luxNormalizeApproverContactId(raw) {
  if (raw == null || raw === '') return ''
  var id = String(raw).trim()
  if (id === '0') return ''
  var n = parseInt(id, 10)
  if (!Number.isFinite(n) || n <= 0) return ''
  return String(n)
}

function luxCanChooseInternalApprover(tier, data) {
  if (!data) return false
  var suffix = tier === 'first' ? 'First' : 'Second'
  return (
    !luxNormalizeApproverContactId(data['preferred' + suffix + 'ApproverContactId']) ||
    data['allowOverride' + suffix + 'InternalApprover'] === true
  )
}

function luxDisplayNameFromAuth() {
  var userEmail = JSON.parse(localStorage.auth).email.replace(/\./g, ' ')
  var userName = userEmail.substring(0, userEmail.indexOf('@'))
  return userName
    .split(' ')
    .map(function (w) {
      return w.charAt(0).toUpperCase() + w.slice(1)
    })
    .join(' ')
}

function luxIsInvoiceApprovingManagerEmail(email, managerEmails) {
  if (!email || !managerEmails || !managerEmails.length) return false
  var normalized = String(email).toLowerCase()
  return managerEmails.some(function (e) {
    return String(e).toLowerCase() === normalized
  })
}

/** Role-pool eligibility for the actor or any contact they actively represent. */
function luxIsEligibleApproverViaSelfOrVertretung(
  currentEmail,
  substitutedEmails,
  managerEmails
) {
  if (luxIsInvoiceApprovingManagerEmail(currentEmail, managerEmails)) return true
  var emails = Array.isArray(substitutedEmails) ? substitutedEmails : []
  for (var i = 0; i < emails.length; i++) {
    if (luxIsInvoiceApprovingManagerEmail(emails[i], managerEmails)) return true
  }
  return false
}

function luxConfirmManagerOverwriteApproval(approverLabel) {
  return window.confirm(
    'Sie sind nicht als Freigeber für die ' +
      approverLabel +
      ' vorgesehen. Möchten Sie die Freigabe trotzdem erteilen?'
  )
}

var LUX_APPROVAL_SLOT_LABEL = {
  base: 'Freigabe',
  first: '2. Freigabe',
  second: '3. Freigabe',
}

function luxNormalizePersonName(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ')
}

function luxCurrentUserDisplayNameMatches(storedName) {
  return luxNormalizePersonName(storedName) === luxNormalizePersonName(luxDisplayNameFromAuth())
}

/** True when API flagged elevated Manager/Verwalter powers (`isCurrentUserManager`). */
function luxIsCurrentUserManager(loadData) {
  return !!(loadData && loadData.isCurrentUserManager)
}

function luxApprovalSlotIsChecked(slot, note, loadData) {
  if (slot === 'base') return !!(note && note.checked)
  if (slot === 'first') {
    return !!(
      (note && note.checkedManagerApproval) ||
      (loadData && loadData.skippedFirstInternalApproval)
    )
  }
  if (slot === 'second') {
    return !!(
      (note && note.checkedSecondInternalApproval) ||
      (loadData && loadData.skippedSecondInternalApproval)
    )
  }
  return false
}

function luxApprovalSlotCheckedByCurrentUser(slot, note) {
  // Live DOM wins: if the user unchecked, do not keep blocking on a stale in-memory mark.
  var el = luxApprovalCheckboxEl(slot)
  if (el && !el.checked) {
    luxUnmarkApprovalCheckedByCurrentUser(slot)
    return false
  }
  if (window.__luxManagerCheckedSlots && window.__luxManagerCheckedSlots[slot]) return true
  if (!note) return false
  if (slot === 'base') {
    return !!(note.checked && luxCurrentUserDisplayNameMatches(note.changedBy))
  }
  if (slot === 'first') {
    return !!(
      note.checkedManagerApproval &&
      luxCurrentUserDisplayNameMatches(note.changedManagerApprovalBy)
    )
  }
  if (slot === 'second') {
    return !!(
      note.checkedSecondInternalApproval &&
      luxCurrentUserDisplayNameMatches(note.changedSecondInternalApprovalBy)
    )
  }
  return false
}

function luxMarkApprovalCheckedByCurrentUser(slot) {
  if (!window.__luxManagerCheckedSlots) window.__luxManagerCheckedSlots = {}
  window.__luxManagerCheckedSlots[slot] = true
}

function luxUnmarkApprovalCheckedByCurrentUser(slot) {
  if (!window.__luxManagerCheckedSlots) return
  delete window.__luxManagerCheckedSlots[slot]
}

function luxHydrateManagerCheckedSlotsFromNote(note) {
  window.__luxManagerCheckedSlots = {}
  if (!note) return
  if (note.checked && luxCurrentUserDisplayNameMatches(note.changedBy)) {
    window.__luxManagerCheckedSlots.base = true
  }
  if (
    note.checkedManagerApproval &&
    luxCurrentUserDisplayNameMatches(note.changedManagerApprovalBy)
  ) {
    window.__luxManagerCheckedSlots.first = true
  }
  if (
    note.checkedSecondInternalApproval &&
    luxCurrentUserDisplayNameMatches(note.changedSecondInternalApprovalBy)
  ) {
    window.__luxManagerCheckedSlots.second = true
  }
}

function luxUserAlreadyCheckedOtherApproval(clickedSlot, note) {
  var slots = ['base', 'first', 'second']
  for (var i = 0; i < slots.length; i++) {
    if (slots[i] === clickedSlot) continue
    if (luxApprovalSlotCheckedByCurrentUser(slots[i], note)) return true
  }
  return false
}

function luxEffectiveApproverForSlot(slot, loadData) {
  if (!loadData || slot === 'base') return null
  var contactId =
    slot === 'first'
      ? luxNormalizeApproverContactId(loadData.requestedFirstApproverContactId) ||
        luxNormalizeApproverContactId(loadData.preferredFirstApproverContactId)
      : luxNormalizeApproverContactId(loadData.requestedSecondApproverContactId) ||
        luxNormalizeApproverContactId(loadData.preferredSecondApproverContactId)
  var email =
    slot === 'first'
      ? loadData.requestedFirstApproverEmail || loadData.preferredFirstApproverEmail
      : loadData.requestedSecondApproverEmail || loadData.preferredSecondApproverEmail
  var name =
    slot === 'first'
      ? loadData.requestedFirstApproverName || loadData.preferredFirstApproverName
      : loadData.requestedSecondApproverName || loadData.preferredSecondApproverName
  if (!contactId && !(email && String(email).trim())) return null
  return {
    contactId: contactId || null,
    email: email ? String(email).trim() : '',
    name: name || null,
  }
}

function luxSubstitutedContactIdSet(loadDataOrIds) {
  var ids = Array.isArray(loadDataOrIds)
    ? loadDataOrIds
    : (loadDataOrIds && loadDataOrIds.substitutedContactIds) || []
  var set = {}
  for (var i = 0; i < ids.length; i++) {
    var id = luxNormalizeApproverContactId(ids[i])
    if (id) set[String(id)] = true
  }
  return set
}

function luxContactIdInSubstitutedSet(contactId, substitutedIds) {
  var id = luxNormalizeApproverContactId(contactId)
  if (!id) return false
  return !!luxSubstitutedContactIdSet(substitutedIds)[String(id)]
}

/** Email-only assignees: match via emails of contacts the actor represents. */
function luxEmailInSubstitutedEmails(email, loadDataOrEmails) {
  var needle = String(email || '')
    .trim()
    .toLowerCase()
  if (!needle) return false
  var emails = Array.isArray(loadDataOrEmails)
    ? loadDataOrEmails
    : (loadDataOrEmails && loadDataOrEmails.substitutedContactEmails) || []
  for (var i = 0; i < emails.length; i++) {
    if (String(emails[i] || '').trim().toLowerCase() === needle) return true
  }
  return false
}

function luxIsCurrentUserEffectiveAssignee(slot, loadData) {
  var assignee = luxEffectiveApproverForSlot(slot, loadData)
  if (!assignee) return false
  var currentEmail = ''
  try {
    currentEmail = String(JSON.parse(localStorage.auth).email || '').toLowerCase()
  } catch (e) {
    currentEmail = ''
  }
  var currentContactId =
    (loadData && loadData.currentUserContactId) || window.__luxCurrentContactId || null
  if (
    currentContactId != null &&
    assignee.contactId != null &&
    String(currentContactId) === String(assignee.contactId)
  ) {
    return true
  }
  if (
    assignee.contactId != null &&
    luxContactIdInSubstitutedSet(assignee.contactId, loadData)
  ) {
    return true
  }
  if (assignee.email && luxEmailInSubstitutedEmails(assignee.email, loadData)) {
    return true
  }
  return !!(assignee.email && assignee.email.toLowerCase() === currentEmail)
}

function luxIsSlotAssignedToSomeoneElse(slot, loadData) {
  var assignee = luxEffectiveApproverForSlot(slot, loadData)
  if (!assignee) return false
  return !luxIsCurrentUserEffectiveAssignee(slot, loadData)
}

/**
 * Unassigned slot in Mitarbeiter mode: Freigabe is for the Employee pool.
 * Elevated Managers may still approve, but only after overwrite confirmation.
 */
function luxIsUnassignedPropertyManagerPoolSlot(slot, loadData) {
  if (!loadData || slot === 'base') return false
  if (luxEffectiveApproverForSlot(slot, loadData)) return false
  var mode =
    slot === 'first'
      ? loadData.firstInternalApprovalMode
      : loadData.secondInternalApprovalMode
  return String(mode || '') === 'property_manager'
}

/** Unchecked slots where the current user is the effective assignee. */
function luxPendingAssignedSlotsForCurrentUser(note, loadData) {
  var pending = []
  ;['first', 'second'].forEach(function (slot) {
    if (!luxIsCurrentUserEffectiveAssignee(slot, loadData)) return
    if (luxApprovalSlotIsChecked(slot, note, loadData)) return
    // Dom checkbox may already be checked before note sync
    var el = luxApprovalCheckboxEl(slot)
    if (el && el.checked) return
    pending.push(slot)
  })
  return pending
}

function luxApprovalCheckboxEl(slot) {
  if (slot === 'base') return document.getElementById('freigegeben')
  if (slot === 'first') return document.getElementById('freigegebenManagerApproval')
  if (slot === 'second') return document.getElementById('freigegebenSecondInternal')
  return null
}

function luxConfirmManagerStillCheckApproval(slot, opts) {
  var label = LUX_APPROVAL_SLOT_LABEL[slot] || 'Freigabe'
  opts = opts || {}
  if (opts.assignedToOther && opts.alreadyCheckedOther) {
    return window.confirm(
      'Sie haben bereits eine andere Freigabe erteilt und sind nicht als Freigeber für die ' +
        label +
        ' vorgesehen. Möchten Sie die Freigabe trotzdem erteilen?'
    )
  }
  if (opts.assignedToOther) {
    return luxConfirmManagerOverwriteApproval(label)
  }
  return window.confirm(
    'Sie haben bereits eine andere Freigabe erteilt. Möchten Sie die ' +
      label +
      ' trotzdem erteilen?'
  )
}

function luxConfirmManagerCheckBoth(assignedSlots, clickedSlot) {
  var assignedLabels = (assignedSlots || [])
    .map(function (s) {
      return LUX_APPROVAL_SLOT_LABEL[s] || s
    })
    .join(' und die ')
  var allSlots = (assignedSlots || []).concat([clickedSlot])
  var allLabels = allSlots
    .map(function (s) {
      return LUX_APPROVAL_SLOT_LABEL[s] || s
    })
    .join(' und die ')
  return window.confirm(
    'Sie sind für die ' +
      assignedLabels +
      ' vorgesehen. Möchten Sie die ' +
      allLabels +
      ' gemeinsam erteilen?'
  )
}

/**
 * Manager multi-approval confirms, or non-manager single-approval hard block.
 * Returns { allowed, applyManagerLogic, alsoCheck?, message? }.
 */
function luxPrepareManagerApprovalClick(clickedSlot) {
  if (window.__luxSkipManagerApprovalConfirm) {
    return { allowed: true, applyManagerLogic: true }
  }
  var loadData = window.__luxInvoiceApprovalLoadData
  var note = window.__luxInvoiceNote

  if (!luxIsCurrentUserManager(loadData)) {
    if (luxUserAlreadyCheckedOtherApproval(clickedSlot, note)) {
      return {
        allowed: false,
        applyManagerLogic: false,
        message:
          'Sie haben bereits eine Freigabe erteilt. Weitere Freigaben können nur übersprungen werden.',
      }
    }
    return { allowed: true, applyManagerLogic: false }
  }

  var pendingAssigned = luxPendingAssignedSlotsForCurrentUser(note, loadData).filter(
    function (slot) {
      return slot !== clickedSlot
    }
  )
  if (pendingAssigned.length) {
    if (!luxConfirmManagerCheckBoth(pendingAssigned, clickedSlot)) {
      return { allowed: false, applyManagerLogic: true }
    }
    pendingAssigned.forEach(luxMarkApprovalCheckedByCurrentUser)
    luxMarkApprovalCheckedByCurrentUser(clickedSlot)
    return { allowed: true, applyManagerLogic: true, alsoCheck: pendingAssigned }
  }

  var alreadyCheckedOther = luxUserAlreadyCheckedOtherApproval(clickedSlot, note)
  var assignedToOther =
    luxIsSlotAssignedToSomeoneElse(clickedSlot, loadData) ||
    luxIsUnassignedPropertyManagerPoolSlot(clickedSlot, loadData)
  if (alreadyCheckedOther || assignedToOther) {
    if (
      !luxConfirmManagerStillCheckApproval(clickedSlot, {
        alreadyCheckedOther: alreadyCheckedOther,
        assignedToOther: assignedToOther,
      })
    ) {
      return { allowed: false, applyManagerLogic: true }
    }
  }
  luxMarkApprovalCheckedByCurrentUser(clickedSlot)
  return { allowed: true, applyManagerLogic: true }
}

function luxProgrammaticCheckApprovalSlots(slots) {
  if (!slots || !slots.length) return
  var order = { base: 0, first: 1, second: 2 }
  var sorted = slots.slice().sort(function (a, b) {
    return (order[a] || 0) - (order[b] || 0)
  })
  window.__luxSkipManagerApprovalConfirm = true
  try {
    sorted.forEach(function (slot) {
      var el = luxApprovalCheckboxEl(slot)
      if (!el || el.checked) return
      el.disabled = false
      el.checked = true
      el.dispatchEvent(new Event('change', { bubbles: true }))
    })
  } finally {
    window.__luxSkipManagerApprovalConfirm = false
  }
}

function luxPendingApproverMetaLabel(name) {
  if (!name || !String(name).trim()) return null
  return '— ' + String(name).trim()
}

var LUX_APPROVAL_SOURCE_ICON = {
  invoice: {
    color: '#2563eb',
    description: 'Freigeber für diese Rechnung gewählt',
  },
  property_manager: {
    color: '#16a34a',
    description: 'Mitarbeiter · Immobilie oder Einstellungen',
  },
  manager: {
    color: '#ca8a04',
    description: 'Manager · Immobilie oder Einstellungen',
  },
}

/**
 * Icon next to 2./3. Freigabe title:
 * - invoice-level assignee → blue
 * - mode "all" → hidden (name only)
 * - Mitarbeiter → green
 * - Manager → gold
 */
function luxCreateApprovalSourceIcon() {
  var wrap = document.createElement('span')
  wrap.className = 'lux-approval-source-icon'
  wrap.style.cssText =
    'display:none;position:relative;align-items:center;justify-content:center;flex-shrink:0;cursor:help;'
  wrap.innerHTML =
    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="10"></circle>' +
    '<circle cx="12" cy="10" r="3"></circle>' +
    '<path d="M7 20.662V19a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v1.662"></path>' +
    '</svg>' +
    '<span class="lux-approval-source-tooltip" style="' +
    'display:none;position:absolute;left:calc(100% + 8px);top:50%;transform:translateY(-50%);' +
    'padding:4px 8px;background:#1f2937;color:#fff;font-size:11px;font-weight:500;line-height:1.3;' +
    'white-space:nowrap;border-radius:4px;pointer-events:none;z-index:20;box-shadow:0 2px 8px rgba(0,0,0,0.15);' +
    '"></span>'

  wrap.addEventListener('mouseenter', function () {
    var tip = wrap.querySelector('.lux-approval-source-tooltip')
    if (tip && tip.textContent) tip.style.display = 'block'
  })
  wrap.addEventListener('mouseleave', function () {
    var tip = wrap.querySelector('.lux-approval-source-tooltip')
    if (tip) tip.style.display = 'none'
  })
  return wrap
}

function luxResolveApprovalSourceIconKey(opts) {
  var invoiceAssigned = !!(opts && opts.invoiceAssigned)
  var mode = String((opts && opts.mode) || '')
  if (invoiceAssigned) return 'invoice'
  if (mode === 'all') return null
  if (mode === 'property_manager') return 'property_manager'
  if (mode === 'manager') return 'manager'
  return null
}

function luxUpdateApprovalSourceIcon(iconEl, opts) {
  if (!iconEl) return
  var key = luxResolveApprovalSourceIconKey(opts)
  var tip = iconEl.querySelector('.lux-approval-source-tooltip')
  if (!key || !LUX_APPROVAL_SOURCE_ICON[key]) {
    iconEl.style.display = 'none'
    iconEl.removeAttribute('aria-label')
    if (tip) tip.textContent = ''
    return
  }
  var cfg = LUX_APPROVAL_SOURCE_ICON[key]
  iconEl.style.display = 'inline-flex'
  iconEl.style.color = cfg.color
  iconEl.setAttribute('aria-label', cfg.description)
  if (tip) tip.textContent = cfg.description
}

/** Debug: current user type + what approval actions are allowed. */
function luxLogApprovalDebugCapabilities(loadData, note) {
  var isElevatedManager = luxIsCurrentUserManager(loadData)
  var email = ''
  try {
    email = String(JSON.parse(localStorage.auth).email || '').toLowerCase()
  } catch (e) {
    email = ''
  }
  var alreadyChecked = {
    freigabe: luxApprovalSlotCheckedByCurrentUser('base', note),
    secondFreigabe: luxApprovalSlotCheckedByCurrentUser('first', note),
    thirdFreigabe: luxApprovalSlotCheckedByCurrentUser('second', note),
  }
  var hasCheckedAny =
    alreadyChecked.freigabe || alreadyChecked.secondFreigabe || alreadyChecked.thirdFreigabe
  var actions = isElevatedManager
    ? [
        'check assigned approval',
        'check another approval with confirm (if already checked one)',
        'overwrite different assignee with confirm',
        'check both when assigned to unchecked slot but clicking another',
        'change assignee / skip via menu',
      ]
    : [
        'check only if assigned to that approval',
        hasCheckedAny
          ? 'cannot check another approval (must skip manually)'
          : 'can check one approval only',
        'change assignee / skip via menu',
      ]

  console.log('[Lux approvals debug]', {
    userType: isElevatedManager ? 'manager' : 'normal_user',
    email: email,
    currentUserContactId: (loadData && loadData.currentUserContactId) || null,
    isCurrentUserManager: !!(loadData && loadData.isCurrentUserManager),
    alreadyChecked: alreadyChecked,
    modes: {
      first: (loadData && loadData.firstInternalApprovalMode) || null,
      second: (loadData && loadData.secondInternalApprovalMode) || null,
    },
    actions: actions,
    roleDefinitions: {
      property_manager: {
        technical: 'property_manager',
        apiRole: 'Employee',
        uiText: {
          impowerContactList: 'Mitarbeiter',
          luxFreigabeMode: 'Mitarbeiter',
        },
        meaning:
          'Linked as Employee/Mitarbeiter. Treated as normal_user for toggle powers. Can check a Freigabe only when strictly assigned as Freigeber (or via menu assign/skip).',
      },
      manager: {
        technical: 'manager',
        apiRole: 'Manager (also accepts Verwalter)',
        uiText: {
          impowerContactList: 'Verwalter',
          luxFreigabeMode: 'Manager',
        },
        meaning:
          'Linked as Manager/Verwalter. Gets isCurrentUserManager=true. Can toggle 2./3. Freigabe without being assigned; can overwrite/skip with confirm; multi-check.',
      },
      all: {
        technical: 'all',
        apiRole: 'Employee + Manager',
        uiText: {
          luxFreigabeMode: 'Alle',
        },
        meaning:
          'Freigabe mode that allows picking either Mitarbeiter or Verwalter as Freigeber. Does not by itself grant elevated toggle powers — that still requires apiRole Manager/Verwalter.',
      },
      normal_user: {
        technical: 'normal_user',
        apiRole: 'not Manager/Verwalter on this property (or unknown)',
        uiText: '—',
        meaning:
          'Anyone who is not detected as elevated Manager. Same toggle rules as Mitarbeiter: only when assigned.',
      },
    },
  })
}

function parseInternalApprovalFetchResponse(response) {
  return response.json().then(function (j) {
    if (!response.ok && j && j.error) {
      j.error = internalApprovalApiErrorToGerman(j.error)
    }
    return { ok: response.ok, j: j }
  })
}

function luxResolvedDomainFromToken() {
  var authData = JSON.parse(localStorage.getItem('auth') || '{}')
  if (!authData.token) return ''
  var decodedToken = JSON.parse(atob(authData.token.split('.')[1]))
  return resolveDomain(decodedToken.domainId || 1)
}

function luxAuthToken() {
  try {
    var raw = localStorage.getItem('auth') || localStorage.auth
    if (!raw) return null
    return JSON.parse(raw).token || null
  } catch (e) {
    return null
  }
}

function secondInternalAuthHeaders() {
  var token = luxAuthToken()
  return {
    'Content-Type': 'application/json',
    Authorization: token ? 'Bearer ' + token : '',
  }
}

function mapLuxEmployeeContacts(data) {
  return (data?.contacts || []).map(function (c) {
    var name =
      c.name ||
      [c.firstName, c.lastName].filter(Boolean).join(' ').trim() ||
      c.email ||
      String(c.id)
    return { id: c.id, name: name, email: c.email || c.contactEmail || '' }
  })
}

function mapLuxContactRecords(contacts) {
  return (contacts || [])
    .filter(Boolean)
    .map(function (c) {
      var email = (c.details && c.details.email && c.details.email[0]) || c.email || ''
      var name =
        [c.firstName, c.lastName].filter(Boolean).join(' ').trim() ||
        c.companyName ||
        email ||
        String(c.id)
      return { id: c.id, name: name, email: email }
    })
}

function isInvoiceApprovingManagerRole(role) {
  if (!role) return false
  var normalized = String(role).trim().toLowerCase()
  return normalized === 'manager' || normalized === 'verwalter'
}

function isPropertyManagerRole(role) {
  if (!role) return false
  return String(role).trim().toLowerCase() === 'employee'
}

function mapManagementCompanyLinks(links, mode) {
  if (mode === 'all') {
    var seen = {}
    return mapManagementCompanyLinks(links, 'manager')
      .concat(mapManagementCompanyLinks(links, 'property_manager'))
      .filter(function (c) {
        var key = String(c.id)
        if (seen[key]) return false
        seen[key] = true
        return true
      })
  }
  return (links || [])
    .filter(function (link) {
      return mode === 'manager'
        ? isInvoiceApprovingManagerRole(link.role)
        : isPropertyManagerRole(link.role)
    })
    .map(function (link) {
      var email = (link.contactEmail || '').trim()
      var name =
        (link.linkedContactName || '').trim() ||
        [link.contactFirstName, link.contactLastName].filter(Boolean).join(' ').trim() ||
        email ||
        String(link.contactId)
      return { id: link.contactId, name: name, email: email }
    })
    .filter(function (c) {
      return c.id != null
    })
}

function fetchInternalApprovalContactOptions(mode, propertyHrId) {
  if (!propertyHrId) return Promise.resolve([])
  return fetch(baseApiUrl + '/api/impowerX/internal-approval-settings?propertyHrId=' + encodeURIComponent(propertyHrId) + '&mode=' + encodeURIComponent(mode), {
    headers: secondInternalAuthHeaders(),
  }).then(function (r) {
    if (!r.ok) throw new Error('Freigeber konnten nicht geladen werden.')
    return r.json()
  }).then(function (data) { return data.contacts || [] })
}

function fetchSecondApproverContactOptions(mode, propertyHrId) {
  return fetchInternalApprovalContactOptions(mode, propertyHrId)
}

function pickDefaultSecondApproverId(options, preferredId, excludeContactId) {
  if (!options.length) return null
  var exclude = excludeContactId != null ? String(excludeContactId) : null
  var eligible = options.filter(function (o) {
    return !exclude || String(o.id) !== exclude
  })
  if (!eligible.length) return null
  if (preferredId && eligible.some(function (o) {
    return String(o.id) === String(preferredId)
  })) {
    return preferredId
  }
  return eligible[Math.floor(Math.random() * eligible.length)].id
}

function luxFirstInternalTierComplete(invoiceNote, loadData) {
  if (loadData && loadData.requiresFirstInternalApproval === false) return true
  if (loadData && loadData.skippedFirstInternalApproval) return true
  return !!(invoiceNote && invoiceNote.checkedManagerApproval)
}

function secondInternalFormatDateTime(iso) {
  return luxFormatInvoiceNoteDateTime(iso)
}

function buildSecondApproverSelectionDialog(options, onConfirm, onClose, copy) {
  buildMultiApproverSelectionDialog(
    [
      {
        key: 'contactId',
        label: null,
        options: options || [],
      },
    ],
    function (values, done) {
      if (!values.contactId) {
        done(true)
        return
      }
      onConfirm(values.contactId, done)
    },
    onClose,
    copy
  )
}

/**
 * One or more Freigeber dropdowns in a single modal.
 * fields: [{ key, label?, options: [{ id, name, email, selected? }] }]
 * onConfirm(valuesByKey, done) — empty string means no assignee for that field
 */
function buildMultiApproverSelectionDialog(fields, onConfirm, onClose, copy) {
  copy = copy || {}
  fields = (fields || []).filter(function (f) {
    return f && f.options && f.options.length
  })
  if (!fields.length) {
    if (onClose) onClose()
    return
  }

  var emptyLabel = copy.emptyLabel || LUX_INTERNAL_APPROVAL_CONTACT_PLACEHOLDER || 'Kontakt wählen…'
  var overlay = document.createElement('div')
  overlay.id = copy.overlayId || 'internal-approver-dialog-overlay'
  overlay.style.cssText =
    'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);display:flex;align-items:center;justify-content:center;z-index:10001;font-family:Arial,sans-serif;'

  var dialog = document.createElement('div')
  dialog.style.cssText =
    'background:#fff;border-radius:8px;box-shadow:0 4px 20px rgba(0,0,0,0.12);width:90%;max-width:440px;'

  var header = document.createElement('div')
  header.style.cssText = 'padding:16px 20px;border-bottom:1px solid #e5e5e5;font-size:18px;font-weight:600;'
  header.textContent =
    copy.title ||
    (fields.length > 1 ? 'Freigeber wählen' : 'Freigeber für 3. Freigabe wählen')

  var body = document.createElement('div')
  body.style.cssText = 'padding:20px;display:flex;flex-direction:column;gap:16px;'

  var hint = document.createElement('p')
  hint.style.cssText = 'margin:0;font-size:13px;color:#666;'
  hint.textContent =
    copy.hint ||
    (fields.length > 1
      ? 'Bitte wählen Sie optional Freigeber für die offenen Freigaben. Felder dürfen leer bleiben.'
      : 'Bitte wählen Sie optional einen Freigeber. Das Feld darf leer bleiben.')
  body.appendChild(hint)

  var selectsByKey = {}
  fields.forEach(function (field) {
    var fieldWrap = document.createElement('div')
    fieldWrap.style.cssText = 'display:flex;flex-direction:column;gap:6px;'
    if (field.label) {
      var label = document.createElement('label')
      label.style.cssText = 'font-size:13px;font-weight:600;color:#333;'
      label.textContent = field.label
      fieldWrap.appendChild(label)
    }
    var select = document.createElement('select')
    select.className = 'ant-input'
    select.dataset.approverKey = field.key
    select.style.cssText = 'width:100%;padding:8px;font-size:14px;'

    var emptyOpt = document.createElement('option')
    emptyOpt.value = ''
    emptyOpt.textContent = emptyLabel
    select.appendChild(emptyOpt)

    var hasSelected = false
    field.options.forEach(function (opt) {
      var o = document.createElement('option')
      o.value = String(opt.id)
      o.textContent = opt.name + (opt.email ? ' (' + opt.email + ')' : '')
      if (opt.selected) {
        o.selected = true
        hasSelected = true
      }
      select.appendChild(o)
    })
    if (!hasSelected) emptyOpt.selected = true

    fieldWrap.appendChild(select)
    body.appendChild(fieldWrap)
    selectsByKey[field.key] = select
  })

  var footer = document.createElement('div')
  footer.style.cssText =
    'padding:12px 20px 16px;display:flex;justify-content:flex-end;gap:8px;border-top:1px solid #e5e5e5;'

  var cancelBtn = document.createElement('button')
  cancelBtn.type = 'button'
  cancelBtn.className = 'ant-btn'
  cancelBtn.textContent = 'Schließen'

  var confirmBtn = document.createElement('button')
  confirmBtn.type = 'button'
  confirmBtn.className = 'ant-btn ant-btn-primary'
  confirmBtn.textContent = 'Anfrage senden'

  footer.appendChild(cancelBtn)
  footer.appendChild(confirmBtn)

  dialog.appendChild(header)
  dialog.appendChild(body)
  dialog.appendChild(footer)
  overlay.appendChild(dialog)

  function close() {
    overlay.remove()
    document.body.style.overflow = ''
    if (onClose) onClose()
  }

  cancelBtn.onclick = close
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close()
  })

  confirmBtn.onclick = function () {
    var values = {}
    var keys = Object.keys(selectsByKey)
    var hasAnySelection = false
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i]
      var contactId = String(selectsByKey[key].value || '').trim()
      values[key] = contactId
      if (contactId) hasAnySelection = true
    }
    if (!hasAnySelection) {
      close()
      return
    }
    confirmBtn.disabled = true
    confirmBtn.textContent = 'Speichern…'
    onConfirm(values, function done(ok) {
      confirmBtn.disabled = false
      confirmBtn.textContent = 'Anfrage senden'
      if (ok) close()
    })
  }

  document.body.style.overflow = 'hidden'
  document.body.appendChild(overlay)
}

function luxPostInternalApproverAssign(tier, contactId, excludeContactId) {
  var invoiceId = window.location.pathname.split('/').pop()
  var authToken = JSON.parse(localStorage.auth).token
  var body = { tier: tier, actionType: 'assign', contactId: contactId }
  if (excludeContactId != null && String(excludeContactId).trim() !== '') {
    body.excludeContactId = excludeContactId
  }
  return fetch(baseApiUrl + '/api/invoices/' + invoiceId + '/internal-approval', {
    method: 'POST',
    headers: { Authorization: 'Bearer ' + authToken, 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }).then(parseInternalApprovalFetchResponse)
}

function buildSkipSecondInternalDialog(onSuccess) {
  var invoiceId = window.location.pathname.split('/').pop()
  buildSkipApprovalReasonDialog({
    overlayId: 'second-internal-skip-dialog-overlay',
    title: '3. Freigabe überspringen',
    zIndex: 10001,
    radioGroupName: 'second-skip-reason',
    presets: [{ value: 'urgency', label: SECOND_SKIP_REASON_URGENCY }],
    onSuccess: onSuccess,
    submitRequest: function (body) {
      var authToken = JSON.parse(localStorage.auth).token
      return fetch(baseApiUrl + '/api/invoices/' + invoiceId + '/internal-approval', {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + authToken, 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({ tier: 'second', actionType: 'skip' }, body)),
      }).then(parseInternalApprovalFetchResponse)
    },
  })
}

function secondInternalApprovalForInvoice(approvalSection) {
  var state = {
    loadData: null,
    visible: false,
    allowSkip: false,
    skipped: false,
    assignedContactId: null,
    assignedContactEmail: null,
    assignedContactName: null,
    propertyHrId: null,
    secondInternalApprovalMode: null,
    preferredSecondApproverContactId: null,
    preferredSecondApproverName: null,
    preferredSecondApproverEmail: null,
    operationalContactsRaw: null,
    firstApproverExcludeContactId: null,
    managerEmails: [],
    currentUserEmail: JSON.parse(localStorage.auth).email.toLowerCase(),
    firstTierComplete: false,
    currentUserContactId: null,
    substitutedContactIds: [],
    substitutedContactEmails: [],
  }

  var rowWrapper = document.createElement('div')
  rowWrapper.className = 'approval-card-row'
  rowWrapper.dataset.approvalId = 'freigegebenSecondInternalRow'
  rowWrapper.style.cssText = 'display:none;position:relative;width:100%;box-sizing:border-box;'

  var card = document.createElement('div')
  card.className = 'approval-card'
  card.dataset.approvalId = 'freigegebenSecondInternal'
  card.style.cssText =
    'display:flex;align-items:center;justify-content:space-between;padding:8px 12px;background-color:#fff;border:1px solid #e5e5e5;border-radius:4px;width:100%;box-sizing:border-box;transition:all 0.2s ease;'

  var left = document.createElement('div')
  left.style.cssText =
    'display:flex;align-items:center;min-width:0;flex:1;overflow:hidden;'
  var titleRow = document.createElement('div')
  titleRow.style.cssText =
    'display:flex;align-items:center;gap:8px;min-width:0;flex:1;overflow:hidden;'
  var title = document.createElement('span')
  title.textContent = '3. Freigabe'
  title.style.cssText =
    'font-size:14px;font-weight:600;color:#1a1a1a;white-space:nowrap;flex-shrink:0;'
  var pmModeIcon = luxCreateApprovalSourceIcon()
  var meta = document.createElement('span')
  meta.className = 'second-internal-approval-meta'
  meta.style.cssText =
    'padding-right:12px;font-size:11px;color:#999;display:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0;flex:1;'
  titleRow.appendChild(title)
  titleRow.appendChild(pmModeIcon)
  titleRow.appendChild(meta)
  left.appendChild(titleRow)

  function setMetaText(text) {
    if (!text) {
      meta.textContent = ''
      meta.removeAttribute('title')
      meta.style.display = 'none'
      return
    }
    meta.textContent = text
    meta.setAttribute('title', text)
    meta.style.display = 'inline'
  }

  function refreshSourceIcon() {
    luxUpdateApprovalSourceIcon(pmModeIcon, {
      invoiceAssigned: !!(
        luxNormalizeApproverContactId(state.assignedContactId) ||
        (state.assignedContactEmail && String(state.assignedContactEmail).trim())
      ),
      mode: state.secondInternalApprovalMode || 'manager',
    })
  }

  var right = document.createElement('div')
  right.style.cssText = 'display:flex;align-items:center;gap:8px;flex-shrink:0;'

  var toggleWrap = document.createElement('label')
  toggleWrap.style.cssText = 'position:relative;display:inline-block;width:48px;height:26px;flex-shrink:0;'
  var checkbox = document.createElement('input')
  checkbox.type = 'checkbox'
  checkbox.id = 'freigegebenSecondInternal'
  checkbox.style.cssText = 'opacity:0;width:0;height:0;'
  var slider = document.createElement('span')
  slider.style.cssText =
    'position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;background-color:#ccc;opacity:0.5;transition:0.3s;border-radius:26px;'
  var sliderDot = document.createElement('span')
  sliderDot.style.cssText =
    'position:absolute;height:20px;width:20px;left:3px;bottom:3px;background-color:white;transition:0.3s;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,0.2);'
  slider.appendChild(sliderDot)
  toggleWrap.appendChild(checkbox)
  toggleWrap.appendChild(slider)

  var actionsMenu = createLuxApprovalKebabMenu([
    {
      id: 'pick',
      label: 'Freigeber wählen',
      onClick: function () {
        openApproverDialog(false)
      },
    },
    {
      id: 'skip',
      label: 'Überspringen',
      onClick: function () {
        buildSkipSecondInternalDialog(function (result) {
          applySkippedVisual()
          refreshControls()
          if (typeof window.onSecondInternalApprovalSkipped === 'function') {
            window.onSecondInternalApprovalSkipped(result)
          }
        })
      },
    },
  ])

  actionsMenu.container.style.position = 'absolute'
  actionsMenu.container.style.left = '100%'
  actionsMenu.container.style.zIndex = '10'
  actionsMenu.container.style.top = '50%'
  actionsMenu.container.style.transform = 'translateY(-50%)'
  actionsMenu.container.style.marginLeft = '8px'

  right.appendChild(toggleWrap)
  card.appendChild(left)
  card.appendChild(right)
  rowWrapper.appendChild(card)
  rowWrapper.appendChild(actionsMenu.container)
  approvalSection.appendChild(rowWrapper)

  function applySkippedVisual() {
    state.skipped = true
    checkbox.checked = true
    checkbox.disabled = true
    slider.style.backgroundColor = '#eab308'
    sliderDot.style.transform = 'translateX(22px)'
    actionsMenu.hide()
    setMetaText('— übersprungen')
  }

  function applyCheckedVisual(changedBy, changedAt) {
    slider.style.backgroundColor = '#22c55e'
    sliderDot.style.transform = 'translateX(22px)'
    setMetaText('— ' + (changedBy || '') + ', ' + secondInternalFormatDateTime(changedAt))
  }

  function refreshPendingApproverMeta() {
    if (state.skipped || checkbox.checked) return
    var name =
      state.assignedContactName ||
      state.preferredSecondApproverName ||
      null
    var pending = luxPendingApproverMetaLabel(name)
    if (pending) {
      setMetaText(pending)
    } else {
      meta.textContent = ''
      meta.style.display = 'none'
    }
  }

  function isEffectiveSecondApprover() {
    var effectiveId =
      luxNormalizeApproverContactId(state.assignedContactId) ||
      luxNormalizeApproverContactId(state.preferredSecondApproverContactId)
    var effectiveEmail =
      state.assignedContactEmail || state.preferredSecondApproverEmail
    if (!effectiveId && !effectiveEmail) return false
    if (
      state.currentUserContactId != null &&
      effectiveId != null &&
      String(state.currentUserContactId) === String(effectiveId)
    ) {
      return true
    }
    if (
      effectiveId != null &&
      luxContactIdInSubstitutedSet(effectiveId, state.substitutedContactIds)
    ) {
      return true
    }
    if (
      effectiveEmail &&
      luxEmailInSubstitutedEmails(effectiveEmail, state.substitutedContactEmails)
    ) {
      return true
    }
    return (
      !!effectiveEmail &&
      effectiveEmail.toLowerCase() === state.currentUserEmail
    )
  }

  function hasDefinedSecondApprover() {
    return !!(
      luxNormalizeApproverContactId(state.assignedContactId) ||
      luxNormalizeApproverContactId(state.preferredSecondApproverContactId) ||
      (state.assignedContactEmail && String(state.assignedContactEmail).trim()) ||
      (state.preferredSecondApproverEmail && String(state.preferredSecondApproverEmail).trim())
    )
  }

  function isManager() {
    return luxIsCurrentUserManager(window.__luxInvoiceApprovalLoadData)
  }

  function isPropertyManagerPoolMember() {
    return (
      String(state.secondInternalApprovalMode || '') !== 'user' &&
      luxIsEligibleApproverViaSelfOrVertretung(
        state.currentUserEmail,
        state.substitutedContactEmails,
        state.managerEmails
      )
    )
  }

  function prepareSecondInternalToggle(wantChecked) {
    if (!wantChecked) return { allowed: true }
    if (state.skipped) return { allowed: false }

    var managerPrep = luxPrepareManagerApprovalClick('second')
    if (!managerPrep.allowed) {
      return { allowed: false, message: managerPrep.message }
    }
    if (managerPrep.applyManagerLogic) {
      return { allowed: true, alsoCheck: managerPrep.alsoCheck }
    }

    if (!hasDefinedSecondApprover()) {
      if (isPropertyManagerPoolMember()) return { allowed: true }
      return {
        allowed: false,
        message: 'Bitte wählen Sie zuerst einen Freigeber.',
      }
    }
    if (isEffectiveSecondApprover()) return { allowed: true }
    return {
      allowed: false,
      message: 'Sie sind nicht berechtigt, die 3. Freigabe zu erteilen.',
    }
  }

  function refreshControls() {
    var showPick =
      !state.skipped && !checkbox.checked && luxCanChooseInternalApprover('second', state.loadData)
    actionsMenu.setItemVisible('pick', showPick)
    actionsMenu.setItemVisible(
      'skip',
      state.allowSkip && !state.skipped && !checkbox.checked
    )
    actionsMenu.refreshMenuVisible()
    refreshCheckboxDisabled()
    refreshPendingApproverMeta()
  }

  function refreshCheckboxDisabled() {
    slider.style.opacity = '0.5'
    if (state.skipped) {
      checkbox.disabled = true
      slider.style.cursor = 'not-allowed'
      card.style.opacity = ''
      return
    }
    if (!hasDefinedSecondApprover()) {
      if (isManager() || isPropertyManagerPoolMember()) {
        checkbox.disabled = false
        slider.style.cursor = 'pointer'
        card.style.opacity = ''
        return
      }
      checkbox.disabled = true
      slider.style.cursor = 'not-allowed'
      card.style.opacity = '0.6'
      return
    }
    if (!isManager() && !isEffectiveSecondApprover()) {
      checkbox.disabled = true
      slider.style.cursor = 'not-allowed'
      card.style.opacity = '0.6'
      return
    }
    checkbox.disabled = false
    slider.style.cursor = 'pointer'
    card.style.opacity = ''
  }

  function postSecondInternalApproval(checked) {
    var userEmail = JSON.parse(localStorage.auth).email.replace(/\./g, ' ')
    var userName = userEmail.substring(0, userEmail.indexOf('@'))
    userName = userName
      .split(' ')
      .map(function (w) {
        return w.charAt(0).toUpperCase() + w.slice(1)
      })
      .join(' ')
    var formattedDate = luxFormatInvoiceNoteNow()
    var metaOnCheck = '— ' + userName + ', ' + formattedDate

    if (checked) {
      setMetaText(metaOnCheck)
    } else {
      setMetaText('')
    }

    var xhr = new XMLHttpRequest()
    xhr.open('POST', baseApiUrl + '/api/invoiceNotes/set', true)
    xhr.setRequestHeader('Content-Type', 'application/json')
    xhr.setRequestHeader('Authorization', 'Bearer ' + JSON.parse(localStorage.auth).token)
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return
      if (xhr.status >= 200 && xhr.status < 300) {
        if (checked && window.__luxInvoiceNote) {
          var savedAt = new Date().toISOString()
          window.__luxInvoiceNote.checkedSecondInternalApproval = true
          window.__luxInvoiceNote.changedSecondInternalApprovalBy = userName
          window.__luxInvoiceNote.changedSecondInternalApprovalAt = savedAt
          window.__luxInvoiceNote.checkedSecondInternalApprovalAt = savedAt
        } else if (!checked && window.__luxInvoiceNote) {
          window.__luxInvoiceNote.checkedSecondInternalApproval = false
          window.__luxInvoiceNote.changedSecondInternalApprovalBy = null
          luxUnmarkApprovalCheckedByCurrentUser('second')
        }
        if (checked) setMetaText(metaOnCheck)
        else refreshPendingApproverMeta()
        refreshControls()
        return
      }
      checkbox.checked = !checked
      if (checked) {
        luxUnmarkApprovalCheckedByCurrentUser('second')
        slider.style.backgroundColor = '#ccc'
        sliderDot.style.transform = 'translateX(0)'
        refreshPendingApproverMeta()
      } else {
        luxMarkApprovalCheckedByCurrentUser('second')
        slider.style.backgroundColor = '#22c55e'
        sliderDot.style.transform = 'translateX(22px)'
        setMetaText(metaOnCheck)
      }
      refreshControls()
      alert(
        xhr.status === 403
          ? xhr.responseText &&
            String(xhr.responseText).indexOf('already accepted another approval') !== -1
            ? 'Sie haben bereits eine Freigabe erteilt. Weitere Freigaben können nur übersprungen werden.'
            : 'Die zweite interne Freigabe ist einem anderen Freigeber zugewiesen. Nur der zugewiesene Freigeber kann diese Freigabe erteilen.'
          : '3. Freigabe konnte nicht gespeichert werden.'
      )
    }
    xhr.send(
      JSON.stringify({
        userName: userName,
        date: formattedDate,
        invoiceHrId: window.location.pathname.split('/').pop(),
        domain: luxResolvedDomainFromToken(),
        eventType: checked ? 'SECOND_INTERNAL_APPROVAL_ACCEPTED' : 'SECOND_INTERNAL_APPROVAL_DENIED',
      })
    )
  }

  checkbox.addEventListener('change', function () {
    var wantChecked = this.checked
    if (wantChecked) {
      var togglePrep = prepareSecondInternalToggle(wantChecked)
      if (!togglePrep.allowed) {
        this.checked = false
        slider.style.backgroundColor = '#ccc'
        sliderDot.style.transform = 'translateX(0)'
        if (togglePrep.message) alert(togglePrep.message)
        return
      }
      if (togglePrep.alsoCheck && togglePrep.alsoCheck.length) {
        luxProgrammaticCheckApprovalSlots(togglePrep.alsoCheck)
      }
      luxMarkApprovalCheckedByCurrentUser('second')
    } else {
      luxUnmarkApprovalCheckedByCurrentUser('second')
      if (window.__luxInvoiceNote) {
        window.__luxInvoiceNote.checkedSecondInternalApproval = false
      }
    }
    if (this.checked) {
      slider.style.backgroundColor = '#22c55e'
      sliderDot.style.transform = 'translateX(22px)'
    } else {
      slider.style.backgroundColor = '#ccc'
      sliderDot.style.transform = 'translateX(0)'
    }
    postSecondInternalApproval(this.checked)
    refreshControls()
  })

  function openApproverDialog(autoOpen) {
    if (!luxCanChooseInternalApprover('second', state.loadData)) return
    var invoiceId = window.location.pathname.split('/').pop()
    var authToken = JSON.parse(localStorage.auth).token
    var mode = state.secondInternalApprovalMode || 'manager'
    if (!state.propertyHrId) {
      if (!autoOpen) alert('Keine Freigeber verfügbar.')
      return
    }
    fetchSecondApproverContactOptions(mode, state.propertyHrId).then(
      function (eligibleApprovers) {
        if (!eligibleApprovers.length) {
          if (autoOpen) return
          alert('Keine Freigeber verfügbar.')
          return
        }
        var defaultId =
          state.assignedContactId ||
          pickDefaultSecondApproverId(
            eligibleApprovers,
            state.preferredSecondApproverContactId,
            state.firstApproverExcludeContactId
          ) ||
          eligibleApprovers[0].id
        var options = eligibleApprovers.map(function (c) {
          return {
            id: c.id,
            name: c.name,
            email: c.email,
            selected: String(c.id) === String(defaultId),
          }
        })
        buildSecondApproverSelectionDialog(
          options,
          function (contactId, done) {
            fetch(baseApiUrl + '/api/invoices/' + invoiceId + '/internal-approval', {
              method: 'POST',
              headers: { Authorization: 'Bearer ' + authToken, 'Content-Type': 'application/json' },
              body: JSON.stringify({
                tier: 'second',
                actionType: 'assign',
                contactId: contactId,
                excludeContactId: state.firstApproverExcludeContactId,
              }),
            })
              .then(parseInternalApprovalFetchResponse)
              .then(function (res) {
                if (!res.ok) {
                  alert(res.j?.error || 'Freigeber konnte nicht gespeichert werden.')
                  done(false)
                  return
                }
                state.assignedContactId = res.j.contactId
                state.assignedContactEmail = res.j.contactEmail
                state.assignedContactName = res.j.contactName || null
                var loadData = window.__luxInvoiceApprovalLoadData
                if (loadData && res.j) {
                  if (res.j.contactId != null) {
                    loadData.requestedSecondApproverContactId = String(res.j.contactId)
                  }
                  if (res.j.contactEmail) {
                    loadData.requestedSecondApproverEmail = res.j.contactEmail
                  }
                }
                refreshSourceIcon()
                refreshControls()
                done(true)
              })
              .catch(function () {
                alert('Freigeber konnte nicht gespeichert werden.')
                done(false)
              })
          },
          function () {}
        )
      }
    )
  }

  return {
    card: card,
    applyLoadState: function (data, invoiceNote) {
      state.loadData = data
      state.managerEmails = data.secondEligibleApproverEmails || data.invoiceApprovingManagerEmails || []
      state.allowSkip = !!data.allowSkipSecondInternalApproval
      state.currentUserContactId = data.currentUserContactId
      state.substitutedContactIds = Array.isArray(data.substitutedContactIds)
        ? data.substitutedContactIds
        : []
      state.substitutedContactEmails = Array.isArray(data.substitutedContactEmails)
        ? data.substitutedContactEmails
        : []
      state.visible = !!data.requiresSecondInternalApproval
      state.propertyHrId = data.propertyHrId
      state.preferredSecondApproverContactId =
        luxNormalizeApproverContactId(data.preferredSecondApproverContactId) || null
      state.preferredSecondApproverName = data.preferredSecondApproverName || null
      state.preferredSecondApproverEmail = data.preferredSecondApproverEmail || null
      state.secondInternalApprovalMode = data.secondInternalApprovalMode || 'manager'
      state.currentUserEmail = JSON.parse(localStorage.auth).email.toLowerCase()
      rowWrapper.style.display = state.visible ? 'block' : 'none'
      if (!state.visible) return

      state.assignedContactId =
        luxNormalizeApproverContactId(data.requestedSecondApproverContactId) || null
      state.assignedContactEmail = data.requestedSecondApproverEmail
      state.assignedContactName = data.requestedSecondApproverName || null
      refreshSourceIcon()
      state.firstTierComplete = luxFirstInternalTierComplete(invoiceNote, data)
      if (data.skippedSecondInternalApproval) {
        applySkippedVisual()
      } else if (invoiceNote?.checkedSecondInternalApproval) {
        checkbox.checked = true
        applyCheckedVisual(
          invoiceNote.changedSecondInternalApprovalBy,
          invoiceNote.checkedSecondInternalApprovalAt ||
            invoiceNote.changedSecondInternalApprovalAt
        )
      }
      refreshControls()
    },
    onFirstApprovalChecked: function () {
      if (!state.visible || state.skipped) return
      // No need to pick a 3rd approver if 3. Freigabe is already done.
      if (checkbox.checked) return
      if (
        window.__luxInvoiceNote &&
        window.__luxInvoiceNote.checkedSecondInternalApproval
      ) {
        return
      }
      if (state.assignedContactId) return
      if (window.__luxCurrentContactId != null) {
        state.firstApproverExcludeContactId = window.__luxCurrentContactId
      }
      openApproverDialog(true)
    },
    openApproverDialog: function () {
      openApproverDialog(false)
    },
    setFirstTierComplete: function (complete) {
      state.firstTierComplete = !!complete
      refreshControls()
    },
    prepareSecondInternalToggle: prepareSecondInternalToggle,
    applyAssignedContact: function (res) {
      if (!res) return
      if (res.contactId != null) {
        state.assignedContactId = luxNormalizeApproverContactId(res.contactId) || null
      }
      if (res.contactEmail) state.assignedContactEmail = res.contactEmail
      if (res.contactName) state.assignedContactName = res.contactName
      var loadData = window.__luxInvoiceApprovalLoadData
      if (loadData) {
        if (res.contactId != null) {
          loadData.requestedSecondApproverContactId = String(res.contactId)
        }
        if (res.contactEmail) loadData.requestedSecondApproverEmail = res.contactEmail
        if (res.contactName) loadData.requestedSecondApproverName = res.contactName
      }
      refreshSourceIcon()
      refreshControls()
    },
  }
}

function luxEnsureApprovalSpinnerStyles() {
  if (document.getElementById('approval-card-styles')) return
  var style = document.createElement('style')
  style.id = 'approval-card-styles'
  style.textContent =
    '@keyframes approvalSpin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }' +
    '.approval-spinner { animation: approvalSpin 0.8s linear infinite; }'
  document.head.appendChild(style)
}

function buildSkipFirstInternalDialog(onSuccess) {
  var invoiceId = window.location.pathname.split('/').pop()
  buildSkipApprovalReasonDialog({
    overlayId: 'first-internal-skip-dialog-overlay',
    title: '2. Freigabe überspringen',
    zIndex: 10001,
    radioGroupName: 'first-skip-reason',
    presets: [{ value: 'urgency', label: SECOND_SKIP_REASON_URGENCY }],
    onSuccess: onSuccess,
    submitRequest: function (body) {
      var authToken = JSON.parse(localStorage.auth).token
      return fetch(baseApiUrl + '/api/invoices/' + invoiceId + '/internal-approval', {
        method: 'POST',
        headers: { Authorization: 'Bearer ' + authToken, 'Content-Type': 'application/json' },
        body: JSON.stringify(Object.assign({ tier: 'first', actionType: 'skip' }, body)),
      }).then(parseInternalApprovalFetchResponse)
    },
  })
}

function enhanceFirstInternalManagerApproval(managerApproval, getLoadData) {
  if (!managerApproval || managerApproval.__luxFirstEnhanced) return
  managerApproval.__luxFirstEnhanced = true

  var rowWrapper = document.createElement('div')
  rowWrapper.className = 'approval-card-row'
  rowWrapper.dataset.approvalId = 'freigegebenFirstInternalRow'
  rowWrapper.style.cssText = 'display:none;position:relative;width:100%;box-sizing:border-box;'

  var card = managerApproval.card
  var parent = card.parentElement
  if (parent) {
    parent.insertBefore(rowWrapper, card)
  }
  card.style.display = 'flex'
  card.style.width = '100%'
  card.style.boxSizing = 'border-box'
  rowWrapper.appendChild(card)

  var titleEl = card.querySelector('.approval-card-title, span')
  if (titleEl) titleEl.textContent = '2. Freigabe'

  var pmModeIcon = luxCreateApprovalSourceIcon()
  if (titleEl && titleEl.parentElement) {
    titleEl.parentElement.insertBefore(pmModeIcon, titleEl.nextSibling)
  }

  var state = {
    allowSkip: false,
    skipped: false,
    assigned: false,
    requiresFirstInternal: false,
    managerEmails: [],
    currentUserEmail: '',
    assignedContactEmail: null,
    assignedContactName: null,
    saving: false,
    currentUserContactId: null,
    substitutedContactIds: [],
    substitutedContactEmails: [],
    preferredFirstApproverContactId: null,
    preferredFirstApproverName: null,
    preferredFirstApproverEmail: null,
    firstInternalApprovalMode: 'manager',
  }

  function refreshSourceIcon() {
    var data = getLoadData ? getLoadData() : null
    luxUpdateApprovalSourceIcon(pmModeIcon, {
      invoiceAssigned: !!(
        luxNormalizeApproverContactId(data && data.requestedFirstApproverContactId) ||
        (state.assignedContactEmail && String(state.assignedContactEmail).trim())
      ),
      mode: state.firstInternalApprovalMode || 'manager',
    })
  }

  function isEffectiveFirstApprover() {
    var data = getLoadData ? getLoadData() : null
    var effectiveId =
      luxNormalizeApproverContactId(data && data.requestedFirstApproverContactId) ||
      luxNormalizeApproverContactId(state.preferredFirstApproverContactId)
    var effectiveEmail =
      state.assignedContactEmail || state.preferredFirstApproverEmail
    if (!effectiveId && !effectiveEmail) return false
    if (
      state.currentUserContactId != null &&
      effectiveId != null &&
      String(state.currentUserContactId) === String(effectiveId)
    ) {
      return true
    }
    if (
      effectiveId != null &&
      luxContactIdInSubstitutedSet(
        effectiveId,
        (data && data.substitutedContactIds) || state.substitutedContactIds
      )
    ) {
      return true
    }
    if (
      effectiveEmail &&
      luxEmailInSubstitutedEmails(
        effectiveEmail,
        (data && data.substitutedContactEmails) || state.substitutedContactEmails
      )
    ) {
      return true
    }
    return (
      !!effectiveEmail &&
      effectiveEmail.toLowerCase() === state.currentUserEmail
    )
  }

  function hasDefinedFirstApprover() {
    var data = getLoadData ? getLoadData() : null
    return !!(
      luxNormalizeApproverContactId(data && data.requestedFirstApproverContactId) ||
      luxNormalizeApproverContactId(state.preferredFirstApproverContactId) ||
      (state.assignedContactEmail && String(state.assignedContactEmail).trim()) ||
      (state.preferredFirstApproverEmail && String(state.preferredFirstApproverEmail).trim())
    )
  }

  function refreshPendingFirstApproverMeta() {
    if (state.skipped || managerApproval.checkbox.checked) return
    var name =
      state.assignedContactName ||
      state.preferredFirstApproverName ||
      null
    var pending = luxPendingApproverMetaLabel(name)
    if (pending) {
      managerApproval.metaLabel.textContent = pending
      managerApproval.metaLabel.style.display = 'inline'
    } else {
      managerApproval.metaLabel.textContent = ''
      managerApproval.metaLabel.style.display = 'none'
    }
  }

  function isManager() {
    return luxIsCurrentUserManager(
      (getLoadData && getLoadData()) || window.__luxInvoiceApprovalLoadData
    )
  }

  function canApproveFirstInternal() {
    if (state.skipped) return false
    if (!hasDefinedFirstApprover()) {
      if (isManager()) return true
      var loadData =
        (getLoadData && getLoadData()) || window.__luxInvoiceApprovalLoadData
      var mode = (loadData && loadData.firstInternalApprovalMode) || 'manager'
      if (
        mode !== 'user' &&
        luxIsEligibleApproverViaSelfOrVertretung(
          state.currentUserEmail,
          state.substitutedContactEmails ||
            (loadData && loadData.substitutedContactEmails),
          state.managerEmails
        )
      ) {
        return true
      }
      return !state.requiresFirstInternal
    }
    if (isEffectiveFirstApprover()) return true
    return isManager()
  }

  function refreshCheckboxDisabled() {
    managerApproval.slider.style.opacity = '0.5'
    if (state.saving) {
      managerApproval.checkbox.disabled = true
      managerApproval.slider.style.cursor = 'wait'
      return
    }
    if (state.skipped) {
      managerApproval.checkbox.disabled = true
      managerApproval.slider.style.cursor = 'not-allowed'
      card.style.opacity = ''
      return
    }
    if (!canApproveFirstInternal()) {
      managerApproval.checkbox.disabled = true
      managerApproval.slider.style.cursor = 'not-allowed'
      card.style.opacity = '0.6'
      return
    }
    managerApproval.checkbox.disabled = false
    managerApproval.slider.style.cursor = 'pointer'
    card.style.opacity = ''
    refreshPendingFirstApproverMeta()
  }

  var actionsMenu = createLuxApprovalKebabMenu([
    {
      id: 'pick',
      label: 'Freigeber wählen',
      onClick: function () {
        openFirstApproverDialog(false)
      },
    },
    {
      id: 'skip',
      label: 'Überspringen',
      onClick: function () {
        buildSkipFirstInternalDialog(function () {
          state.skipped = true
          managerApproval.checkbox.checked = true
          managerApproval.checkbox.disabled = true
          managerApproval.slider.style.backgroundColor = '#eab308'
          managerApproval.sliderDot.style.transform = 'translateX(22px)'
          managerApproval.metaLabel.textContent = '— übersprungen'
          managerApproval.metaLabel.style.display = 'inline'
          actionsMenu.hide()
          if (window.secondInternalApprovalUI && window.secondInternalApprovalUI.setFirstTierComplete) {
            window.secondInternalApprovalUI.setFirstTierComplete(true)
          }
        })
      },
    },
  ])
  actionsMenu.container.style.position = 'absolute'
  actionsMenu.container.style.left = '100%'
  actionsMenu.container.style.top = '50%'
  actionsMenu.container.style.transform = 'translateY(-50%)'
  actionsMenu.container.style.marginLeft = '8px'
  rowWrapper.appendChild(actionsMenu.container)

  luxEnsureApprovalSpinnerStyles()
  var managerSaveSpinner = document.createElement('div')
  managerSaveSpinner.className = 'approval-spinner'
  managerSaveSpinner.style.cssText =
    'display:none;width:18px;height:18px;border:2px solid rgba(0,0,0,0.15);border-top-color:#1890ff;border-radius:50%;flex-shrink:0;margin-right:6px;'
  card.insertBefore(managerSaveSpinner, managerApproval.slider.parentElement)

  function setManagerApprovalSaving(saving) {
    state.saving = !!saving
    if (saving) {
      managerApproval.checkbox.disabled = true
      managerSaveSpinner.style.display = 'block'
      managerApproval.slider.style.backgroundColor = '#ccc'
      managerApproval.sliderDot.style.transform = 'translateX(0)'
      actionsMenu.hide()
      return
    }
    managerSaveSpinner.style.display = 'none'
    refreshCheckboxDisabled()
  }

  function applyManagerApprovalSavedVisual(checked, metaText) {
    if (checked) {
      managerApproval.slider.style.backgroundColor = '#22c55e'
      managerApproval.sliderDot.style.transform = 'translateX(22px)'
      if (metaText) {
        managerApproval.metaLabel.textContent = metaText
        managerApproval.metaLabel.style.display = 'inline'
      }
    } else {
      managerApproval.slider.style.backgroundColor = '#ccc'
      managerApproval.sliderDot.style.transform = 'translateX(0)'
      managerApproval.metaLabel.style.display = 'none'
    }
    refreshMenu()
  }

  function refreshMenu() {
    if (state.skipped) {
      actionsMenu.hide()
      return
    }
    var showPick =
      !managerApproval.checkbox.checked &&
      luxCanChooseInternalApprover('first', getLoadData ? getLoadData() : null)
    actionsMenu.setItemVisible('pick', showPick)
    actionsMenu.setItemVisible('skip', state.allowSkip && !managerApproval.checkbox.checked)
    actionsMenu.refreshMenuVisible()
    refreshPendingFirstApproverMeta()
  }

  function openFirstApproverDialog(autoOpen, onClosed) {
    var data = getLoadData ? getLoadData() : null
    function finish() {
      if (onClosed) onClosed()
    }
    if (!luxCanChooseInternalApprover('first', data)) {
      finish()
      return
    }
    if (!data || !data.propertyHrId) {
      if (!autoOpen) alert('Keine Freigeber verfügbar.')
      finish()
      return
    }
    var mode = (data && data.firstInternalApprovalMode) || 'manager'
    fetchInternalApprovalContactOptions(mode, data.propertyHrId).then(
      function (eligible) {
        if (!eligible.length) {
          if (!autoOpen) alert('Keine Freigeber verfügbar.')
          finish()
          return
        }
        var defaultId =
          data.requestedFirstApproverContactId ||
          data.preferredFirstApproverContactId ||
          eligible[0].id
        buildSecondApproverSelectionDialog(
          eligible.map(function (c) {
            return {
              id: c.id,
              name: c.name,
              email: c.email,
              selected: String(c.id) === String(defaultId),
            }
          }),
          function (contactId, done) {
            var invoiceId = window.location.pathname.split('/').pop()
            var authToken = JSON.parse(localStorage.auth).token
            fetch(baseApiUrl + '/api/invoices/' + invoiceId + '/internal-approval', {
              method: 'POST',
              headers: { Authorization: 'Bearer ' + authToken, 'Content-Type': 'application/json' },
              body: JSON.stringify({ tier: 'first', actionType: 'assign', contactId: contactId }),
            })
              .then(parseInternalApprovalFetchResponse)
              .then(function (res) {
                if (!res.ok) {
                  alert(res.j?.error || 'Freigeber konnte nicht gespeichert werden.')
                  done(false)
                  return
                }
                state.assigned = true
                var loadData = getLoadData ? getLoadData() : null
                if (loadData && res.j) {
                  if (res.j.contactId != null) {
                    loadData.requestedFirstApproverContactId = String(res.j.contactId)
                  }
                  if (res.j.contactEmail) {
                    loadData.requestedFirstApproverEmail = res.j.contactEmail
                    state.assignedContactEmail = res.j.contactEmail
                  }
                  if (res.j.contactName) {
                    state.assignedContactName = res.j.contactName
                  }
                }
                refreshSourceIcon()
                refreshCheckboxDisabled()
                refreshMenu()
                done(true)
              })
              .catch(function () {
                alert('Freigeber konnte nicht gespeichert werden.')
                done(false)
              })
          },
          finish,
          {
            overlayId: 'first-internal-approver-dialog-overlay',
            title: 'Freigeber für 2. Freigabe wählen',
            hint:
              'Bitte wählen Sie, wer die 2. Freigabe erhalten soll. Sie können den Dialog schließen und später erneut öffnen.',
          }
        )
      },
      function () {
        if (!autoOpen) alert('Keine Freigeber verfügbar.')
        finish()
      }
    )
  }

  return {
    rowWrapper: rowWrapper,
    applyLoadState: function (data) {
      state.allowSkip = !!data.allowSkipFirstInternalApproval
      state.requiresFirstInternal = !!data.requiresFirstInternalApproval
      state.managerEmails = data.firstEligibleApproverEmails || data.invoiceApprovingManagerEmails || []
      state.currentUserEmail = JSON.parse(localStorage.auth).email.toLowerCase()
      state.currentUserContactId = data.currentUserContactId
      state.substitutedContactIds = Array.isArray(data.substitutedContactIds)
        ? data.substitutedContactIds
        : []
      state.substitutedContactEmails = Array.isArray(data.substitutedContactEmails)
        ? data.substitutedContactEmails
        : []
      state.preferredFirstApproverContactId =
        luxNormalizeApproverContactId(data.preferredFirstApproverContactId) || null
      state.preferredFirstApproverName = data.preferredFirstApproverName || null
      state.preferredFirstApproverEmail = data.preferredFirstApproverEmail || null
      state.assignedContactEmail = data.requestedFirstApproverEmail || null
      state.assignedContactName = data.requestedFirstApproverName || null
      state.assigned = !!data.requestedFirstApproverContactId
      state.firstInternalApprovalMode = data.firstInternalApprovalMode || 'manager'
      refreshSourceIcon()
      rowWrapper.style.display = data.requiresFirstInternalApproval ? 'block' : 'none'
      if (data.skippedFirstInternalApproval) {
        state.skipped = true
        managerApproval.checkbox.checked = true
        managerApproval.checkbox.disabled = true
        managerApproval.slider.style.backgroundColor = '#eab308'
        managerApproval.sliderDot.style.transform = 'translateX(22px)'
        managerApproval.metaLabel.textContent = '— übersprungen'
        managerApproval.metaLabel.style.display = 'inline'
        actionsMenu.hide()
      }
      refreshCheckboxDisabled()
      refreshMenu()
    },
    prepareManagerToggle: function (wantChecked) {
      if (!wantChecked) {
        return { allowed: canApproveFirstInternal() }
      }

      var managerPrep = luxPrepareManagerApprovalClick('first')
      if (!managerPrep.allowed) {
        return { allowed: false, message: managerPrep.message }
      }
      if (managerPrep.applyManagerLogic) {
        if (!canApproveFirstInternal()) {
          return {
            allowed: false,
            message: 'Sie sind nicht berechtigt, die 2. Freigabe zu erteilen.',
          }
        }
        return { allowed: true, alsoCheck: managerPrep.alsoCheck }
      }

      if (!canApproveFirstInternal()) {
        return {
          allowed: false,
          message: 'Sie sind nicht berechtigt, die 2. Freigabe zu erteilen.',
        }
      }
      return { allowed: true }
    },
    openFirstApproverDialog: openFirstApproverDialog,
    refreshCheckboxDisabled: refreshCheckboxDisabled,
    setManagerApprovalSaving: setManagerApprovalSaving,
    applyManagerApprovalSavedVisual: applyManagerApprovalSavedVisual,
    onBaseApprovalChecked: function () {
      var loadData = getLoadData ? getLoadData() : null
      var note = window.__luxInvoiceNote
      if (!loadData || !loadData.propertyHrId) return

      var firstAlreadyDone =
        state.skipped ||
        managerApproval.checkbox.checked ||
        !!(note && note.checkedManagerApproval)
      var firstRequired = !!loadData.requiresFirstInternalApproval
      var firstAlreadyAssigned =
        state.assigned || !!luxNormalizeApproverContactId(loadData.requestedFirstApproverContactId)

      var secondEl = document.getElementById('freigegebenSecondInternal')
      var secondAlreadyDone =
        !!(loadData.skippedSecondInternalApproval) ||
        !!(secondEl && secondEl.checked) ||
        !!(note && note.checkedSecondInternalApproval)
      var secondRequired = !!loadData.requiresSecondInternalApproval
      var secondAlreadyAssigned = !!luxNormalizeApproverContactId(
        loadData.requestedSecondApproverContactId
      )

      var pending = []
      if (
        firstRequired && !firstAlreadyDone && !firstAlreadyAssigned &&
        luxCanChooseInternalApprover('first', loadData)
      ) {
        pending.push({
          key: 'first',
          label: '2. Freigabe',
          mode: loadData.firstInternalApprovalMode || 'manager',
          preferredId: luxNormalizeApproverContactId(loadData.preferredFirstApproverContactId),
        })
      }
      if (
        secondRequired && !secondAlreadyDone && !secondAlreadyAssigned &&
        luxCanChooseInternalApprover('second', loadData)
      ) {
        pending.push({
          key: 'second',
          label: '3. Freigabe',
          mode: loadData.secondInternalApprovalMode || 'manager',
          preferredId: luxNormalizeApproverContactId(loadData.preferredSecondApproverContactId),
        })
      }
      if (!pending.length) return

      Promise.all(
        pending.map(function (field) {
          return fetchInternalApprovalContactOptions(field.mode, loadData.propertyHrId).then(
            function (contacts) {
              return {
                key: field.key,
                label: field.label,
                preferredId: field.preferredId,
                contacts: contacts || [],
              }
            }
          )
        })
      ).then(function (loaded) {
        var dialogFields = []
        loaded.forEach(function (field) {
          if (!field.contacts.length) return
          dialogFields.push({
            key: field.key,
            label: field.label,
            options: field.contacts.map(function (c) {
              return {
                id: c.id,
                name: c.name,
                email: c.email,
                // Prefer empty by default; preferred contact stays in the list.
                selected: false,
              }
            }),
          })
        })
        if (!dialogFields.length) return

        var title = 'Freigeber wählen'
        var hint = 'Bitte wählen Sie optional Freigeber für die offenen Freigaben. Felder dürfen leer bleiben.'

        buildMultiApproverSelectionDialog(
          dialogFields,
          function (values, done) {
            var chain = Promise.resolve(true)

            if (values.first) {
              chain = chain.then(function (ok) {
                if (!ok) return false
                return luxPostInternalApproverAssign('first', values.first).then(function (res) {
                  if (!res.ok) {
                    alert(res.j?.error || 'Freigeber konnte nicht gespeichert werden.')
                    return false
                  }
                  state.assigned = true
                  if (res.j) {
                    if (res.j.contactId != null) {
                      loadData.requestedFirstApproverContactId = String(res.j.contactId)
                    }
                    if (res.j.contactEmail) {
                      loadData.requestedFirstApproverEmail = res.j.contactEmail
                      state.assignedContactEmail = res.j.contactEmail
                    }
                    if (res.j.contactName) {
                      state.assignedContactName = res.j.contactName
                      loadData.requestedFirstApproverName = res.j.contactName
                    }
                  }
                  refreshSourceIcon()
                  refreshCheckboxDisabled()
                  refreshMenu()
                  return true
                })
              })
            }

            if (values.second) {
              chain = chain.then(function (ok) {
                if (!ok) return false
                var excludeId =
                  values.first ||
                  luxNormalizeApproverContactId(loadData.requestedFirstApproverContactId) ||
                  window.__luxCurrentContactId ||
                  null
                return luxPostInternalApproverAssign('second', values.second, excludeId).then(
                  function (res) {
                    if (!res.ok) {
                      alert(res.j?.error || 'Freigeber konnte nicht gespeichert werden.')
                      return false
                    }
                    if (
                      window.secondInternalApprovalUI &&
                      window.secondInternalApprovalUI.applyAssignedContact
                    ) {
                      window.secondInternalApprovalUI.applyAssignedContact(res.j || {})
                    } else if (res.j) {
                      if (res.j.contactId != null) {
                        loadData.requestedSecondApproverContactId = String(res.j.contactId)
                      }
                      if (res.j.contactEmail) {
                        loadData.requestedSecondApproverEmail = res.j.contactEmail
                      }
                    }
                    return true
                  }
                )
              })
            }

            chain
              .then(function (ok) {
                done(!!ok)
              })
              .catch(function () {
                alert('Freigeber konnte nicht gespeichert werden.')
                done(false)
              })
          },
          function () {},
          {
            overlayId: 'combined-internal-approver-dialog-overlay',
            title: title,
            hint: hint,
          }
        )
      })
    },
    refreshMenu: refreshMenu,
  }
}
var LUX_INTERNAL_APPROVAL_MODE_RADIO_OPTIONS = [
  { label: 'Domainstandard', value: 'inherit', order: 0 },
  { label: 'Mitarbeiter', value: 'property_manager', order: 1 },
  { label: 'Manager', value: 'manager', order: 2 },
  { label: 'Objektbetreuer', value: 'property_supervisor', order: 3 },
  { label: 'Objektbuchhalter', value: 'property_accountant', order: 4 },
  { label: 'Sachbearbeiter', value: 'case_worker', order: 5 },
  { label: 'Sachbearbeiter primär', value: 'primary_case_worker', order: 6 },
  { label: 'Bestimmter Benutzer', value: 'user', order: 7 },
  { label: 'Alle', value: 'all', order: 8 },
]

var LUX_INTERNAL_APPROVAL_CONTACT_PLACEHOLDER = 'Kontakt wählen…'
/** Must match CLEARED_INTERNAL_APPROVAL_PREFERRED_CONTACT on the Lux API. */
var LUX_CLEARED_PREFERRED_APPROVER_CONTACT = '0'

var LUX_INTERNAL_APPROVAL_PROPERTY_FIELD_CATALOG = [
  { name: 'proprety_first_internal_approval_amount_limit', fieldType: 'CurrencyInput', label: '2. Freigabe: Betragsgrenze', order: 50, placeholder: 'Domainstandard (0 = jeder Betrag)', isFullWidth: false },
  { name: 'proprety_second_internal_approval_amount_limit', fieldType: 'CurrencyInput', label: '3. Freigabe: Betragsgrenze', order: 55, placeholder: 'Domainstandard (0 = jeder Betrag)', isFullWidth: false },
  { name: 'proprety_content_approval_mode', fieldType: 'RadioGroup', label: 'Inhaltliche Freigabe', order: 46, isFullWidth: false, options: LUX_INTERNAL_APPROVAL_MODE_RADIO_OPTIONS.slice() },
  { name: 'proprety_content_approver_contact_id', fieldType: 'ContactComboBox', label: 'Inhaltliche Freigabe', order: 47, isFullWidth: false, options: [], withClearBtn: true, placeholder: LUX_INTERNAL_APPROVAL_CONTACT_PLACEHOLDER },
  { name: 'proprety_payment_approval_mode', fieldType: 'RadioGroup', label: 'Freigabe zur Zahlung', order: 48, isFullWidth: false, options: LUX_INTERNAL_APPROVAL_MODE_RADIO_OPTIONS.slice() },
  { name: 'proprety_payment_approver_contact_id', fieldType: 'ContactComboBox', label: 'Freigabe zur Zahlung', order: 49, isFullWidth: false, options: [], withClearBtn: true, placeholder: LUX_INTERNAL_APPROVAL_CONTACT_PLACEHOLDER },
  {
    name: 'proprety_enable_first_internal_approval',
    fieldType: 'CheckboxGroup',
    label: 'Rechnungsfreigaben',
    order: 50,
    isFullWidth: true,
    placeholder: null,
    options: [{ label: '2. Freigabe', value: 'true', order: 0 }],
  },
  {
    name: 'proprety_first_internal_approval_mode',
    fieldType: 'RadioGroup',
    label: '2. Freigabe',
    order: 51,
    isFullWidth: false,
    placeholder: null,
    options: LUX_INTERNAL_APPROVAL_MODE_RADIO_OPTIONS.slice(),
  },
  {
    name: 'proprety_preferred_first_approver_contact_id',
    fieldType: 'ContactComboBox',
    label: '2. Freigabe',
    order: 52,
    isFullWidth: false,
    placeholder: LUX_INTERNAL_APPROVAL_CONTACT_PLACEHOLDER,
    options: [],
    withClearBtn: true,
  },
  {
    name: 'proprety_allow_override_first_internal_approver',
    fieldType: 'CheckboxGroup',
    label: '2. Freigabe',
    order: 53,
    isFullWidth: false,
    placeholder: null,
    options: [{ label: 'Vordefinierten Freigeber ändern möglich', value: 'true', order: 0 }],
  },
  {
    name: 'proprety_allow_skip_first_internal_approval',
    fieldType: 'CheckboxGroup',
    label: '2. Freigabe',
    order: 54,
    isFullWidth: false,
    placeholder: null,
    options: [{ label: 'Überspringen möglich', value: 'true', order: 0 }],
  },
  {
    name: 'proprety_enable_second_internal_approval',
    fieldType: 'CheckboxGroup',
    label: '',
    order: 55,
    isFullWidth: true,
    placeholder: null,
    options: [{ label: '3. Freigabe', value: 'true', order: 0 }],
  },
  {
    name: 'proprety_second_internal_approval_mode',
    fieldType: 'RadioGroup',
    label: '3. Freigabe',
    order: 56,
    isFullWidth: false,
    placeholder: null,
    options: LUX_INTERNAL_APPROVAL_MODE_RADIO_OPTIONS.slice(),
  },
  {
    name: 'proprety_preferred_second_approver_contact_id',
    fieldType: 'ContactComboBox',
    label: '3. Freigabe',
    order: 57,
    isFullWidth: false,
    placeholder: LUX_INTERNAL_APPROVAL_CONTACT_PLACEHOLDER,
    options: [],
    withClearBtn: true,
  },
  {
    name: 'proprety_allow_override_second_internal_approver',
    fieldType: 'CheckboxGroup',
    label: '3. Freigabe',
    order: 58,
    isFullWidth: false,
    placeholder: null,
    options: [{ label: 'Vordefinierten Freigeber ändern möglich', value: 'true', order: 0 }],
  },
  {
    name: 'proprety_allow_skip_second_internal_approval',
    fieldType: 'CheckboxGroup',
    label: '3. Freigabe',
    order: 59,
    isFullWidth: false,
    placeholder: null,
    options: [{ label: 'Überspringen möglich', value: 'true', order: 0 }],
  },
]

var LUX_INTERNAL_APPROVAL_LIMIT_ANCHOR_FIELD_IDS = ['proprety_max_invoice_amount']

function luxInternalApprovalPropertyInsertBeforeRow(propertyCare) {
  if (!propertyCare) return null
  var lastAnchorRow = null
  propertyCare.querySelectorAll('.sub-section-content-row').forEach(function (row) {
    for (var i = 0; i < LUX_INTERNAL_APPROVAL_LIMIT_ANCHOR_FIELD_IDS.length; i++) {
      var fieldId = LUX_INTERNAL_APPROVAL_LIMIT_ANCHOR_FIELD_IDS[i]
      if (row.querySelector('#' + fieldId + ', [name="' + fieldId + '"]')) {
        lastAnchorRow = row
      }
    }
  })
  if (!lastAnchorRow) return null
  var next = lastAnchorRow.nextElementSibling
  while (next && next.classList && next.classList.contains('sub-section-content-row')) {
    if (next.querySelector('.impowerx-currency-input')) {
      lastAnchorRow = next
      next = next.nextElementSibling
    } else {
      break
    }
  }
  return lastAnchorRow.nextElementSibling
}

function luxRepositionInternalApprovalPropertyWrapper(propertyCare) {
  if (!propertyCare) return
  var wrapper = propertyCare.querySelector('.lux-internal-approval-settings')
  var insertBefore = luxInternalApprovalPropertyInsertBeforeRow(propertyCare)
  if (!wrapper || !insertBefore || wrapper === insertBefore) return
  propertyCare.insertBefore(wrapper, insertBefore)
}

function ensureInternalApprovalPropertyFields(allFields) {
  var catalogByName = {}
  LUX_INTERNAL_APPROVAL_PROPERTY_FIELD_CATALOG.forEach(function (def) {
    catalogByName[def.name] = def
  })
  var rest = (allFields || []).filter(function (f) {
    return !catalogByName[f.name] && f.name !== 'proprety_max_invoice_amount'
  })
  var approval = LUX_INTERNAL_APPROVAL_PROPERTY_FIELD_CATALOG.map(function (def) {
    var existing = (allFields || []).find(function (f) {
      return f.name === def.name
    })
    if (!existing && /_internal_approval_amount_limit$/.test(def.name)) {
      var legacy = (allFields || []).find(function (f) { return f.name === 'proprety_max_invoice_amount' })
      // Only retain the value: the new field must not reuse the old field ID.
      if (legacy) existing = { value: legacy.value }
    }
    var merged = Object.assign(
      {
        section: 'AdministrationData',
        subSection: 'PropertyCare',
        isRequired: false,
        value: existing && existing.value != null ? existing.value : '',
      },
      existing || {},
      def
    )
    if (/_internal_approval_amount_limit$/.test(def.name)) {
      merged.inheritsApprovalAmountLimit = merged.value == null || String(merged.value).trim() === ''
      if (merged.inheritsApprovalAmountLimit) {
        merged.value = luxApprovalAmountDomainValue(def.name)
      } else {
        // A saved zero is an explicit property value, never a missing default.
        merged.value = String(merged.value)
      }
    }
    if (def.fieldType === 'RadioGroup') {
      if (!merged.value) merged.value = 'inherit'
      var available = window.__luxPropertyApprovalRoleAvailability || {}
      merged.options = def.options.filter(function (option) {
        if (option.value === 'user' || option.value === 'all') return merged.value === option.value
        return (option.value !== 'case_worker' && option.value !== 'primary_case_worker') || available[option.value] || merged.value === option.value
      })
    }
    // Catalog ContactComboBox defaults to options: []; keep loaded contact options for labels.
    if (
      def.fieldType === 'ContactComboBox' && existing &&
      Array.isArray(existing.options) &&
      existing.options.length > 0
    ) {
      merged.options = existing.options
    }
    return merged
  })
  return rest.concat(approval).sort(function (a, b) {
    return (a.order || 0) - (b.order || 0)
  })
}

function ensureInternalApprovalPropertyStyles() {
  var styleEl = document.getElementById('lux-internal-approval-property-styles')
  var css =
    '.lux-internal-approval-settings{display:flex;flex-direction:column;width:100%;gap:8px;}' +
    '.lux-internal-approval-section{display:flex;flex-direction:column;width:100%;}' +
    '.lux-internal-approval-section-title-row{width:100%;margin:0 0 8px 0;}' +
    '.lux-internal-approval-section-title-row .ant-form-item{margin-bottom:0;}' +
    '.lux-internal-approval-tiers-row{display:flex;flex-direction:column;gap:8px;width:100%;box-sizing:border-box;}' +
    '.lux-internal-approval-tier{width:100%;min-width:0;box-sizing:border-box;padding:16px 16px 32px;border:0;border-radius:0;}' +
    '.lux-internal-approval-tier > [id^="proprety_enable_"]{width:100%;box-sizing:border-box;margin-left:0!important;padding:0 0 16px!important;}' +
    '.lux-internal-approval-tier > [id^="proprety_enable_"] .ant-form-item-label{display:none!important;}' +
    '.lux-internal-approval-tier > [id^="proprety_enable_"] .ant-form-item-control{margin-left:0!important;}' +
    '.lux-internal-approval-tier-body{display:flex;flex-direction:row;flex-wrap:wrap;gap:16px;margin:0;padding:0;border:0;box-sizing:border-box;}' +
    '.lux-internal-approval-tier-body .ehv-element{min-width:0!important;width:100%;box-sizing:border-box;padding:0!important;}' +
    '.lux-internal-approval-tier-body .lux-approval-labeled-field{flex:1 1 260px!important;min-width:min(260px,100%)!important;}' +
    '.lux-internal-approval-tier-body .ehv-element:not(.lux-approval-labeled-field){flex:0 1 auto!important;min-width:min(200px,100%)!important;width:auto;max-width:100%;}' +
    '.lux-internal-approval-tier-body .ehv-element .ant-form-item-label{display:none!important;}' +
    '.lux-internal-approval-tier-body .lux-approval-labeled-field .ant-form-item-label{display:block!important;padding:0 0 6px;}' +
    '.lux-internal-approval-tier-body .ant-form-item-label label{height:auto;min-height:24px;line-height:24px;}' +
    '.lux-internal-approval-tier h4{margin:0 0 16px;font-size:16px;font-weight:600;}' +
    '.lux-internal-approval-tier-body .ant-form-item{margin-bottom:0!important;}' +
    '.lux-internal-approval-tier-body .ant-radio-group{display:block!important;width:100%;}' +
    '.lux-approval-role-dropdown{appearance:none;width:100%;height:40px;padding:6px 40px 6px 16px;border:2px solid #eee;border-radius:6px;background-color:white;background-image:url("data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2210%22 height=%225%22 viewBox=%220 0 10 5%22%3E%3Cpath d=%22M0 0L5 5L10 0Z%22 fill=%22%23000%22/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 16px center;color:#000;font-family:inherit;font-size:16px;font-weight:500;line-height:24px;}' +
    '.lux-internal-approval-tier-body .contact-combobox .ant-select-selector{height:40px!important;padding:6px 16px!important;border:2px solid #eee!important;border-radius:6px!important;}' +
    '.lux-internal-approval-tier-body .contact-combobox .ant-select-selection-item,.lux-internal-approval-tier-body .contact-combobox-search-input{font-family:inherit!important;font-size:16px!important;font-weight:500!important;line-height:24px!important;}' +
    '.lux-internal-approval-tier-body .contact-combobox .ant-select-arrow{right:16px;}' +
    '.lux-approval-role-dropdown:disabled{background-color:#f0f0f0;background-image:none;border-color:transparent;color:rgba(0,0,0,.65);}' +
    '.lux-approval-native-contact > .impowerx-select,.lux-approval-native-contact > .dropdown-wrapper{display:none!important;}' +
    '.lux-approval-has-dropdown > .radio-group-option{display:none!important;}' +
    '.lux-internal-approval-tier-body .ant-radio-wrapper{margin:0;white-space:normal;}'
  if (styleEl) {
    styleEl.textContent = css
    return
  }
  var style = document.createElement('style')
  style.id = 'lux-internal-approval-property-styles'
  style.textContent = css
  document.head.appendChild(style)
}

var LUX_INTERNAL_APPROVAL_TIER_DEFS = [
  { key: 'content', title: 'Inhaltliche Freigabe', mode: 'proprety_content_approval_mode', contact: 'proprety_content_approver_contact_id' },
  { key: 'payment', title: 'Freigabe zur Zahlung', mode: 'proprety_payment_approval_mode', contact: 'proprety_payment_approver_contact_id' },
  {
    key: 'first',
    limit: 'proprety_first_internal_approval_amount_limit',
    enable: 'proprety_enable_first_internal_approval',
    mode: 'proprety_first_internal_approval_mode',
    contact: 'proprety_preferred_first_approver_contact_id',
    override: 'proprety_allow_override_first_internal_approver',
    skip: 'proprety_allow_skip_first_internal_approval',
  },
  {
    key: 'second',
    limit: 'proprety_second_internal_approval_amount_limit',
    enable: 'proprety_enable_second_internal_approval',
    mode: 'proprety_second_internal_approval_mode',
    contact: 'proprety_preferred_second_approver_contact_id',
    override: 'proprety_allow_override_second_internal_approver',
    skip: 'proprety_allow_skip_second_internal_approval',
  },
]

function createLuxInternalApprovalSectionTitleRow() {
  var row = document.createElement('div')
  row.className = 'lux-internal-approval-section-title-row'
  var formItem = document.createElement('div')
  formItem.className = 'ant-row ant-form-item ant-form-item-with-help'
  formItem.style.rowGap = '0px'
  formItem.innerHTML =
    '<div class="ant-col ant-form-item-label"><label title=""><span>Rechnungsfreigaben</span></label></div>'
  row.appendChild(formItem)
  return row
}

function ensureLuxInternalApprovalSectionTitleMarkup() {
  var section = document.querySelector('.lux-internal-approval-section')
  if (!section || section.querySelector('.lux-internal-approval-section-title-row')) return
  var legacy = section.querySelector('.lux-internal-approval-section-title')
  var titleRow = createLuxInternalApprovalSectionTitleRow()
  if (legacy) {
    section.insertBefore(titleRow, legacy)
    legacy.remove()
  } else {
    section.insertBefore(titleRow, section.firstChild)
  }
}

function ensureInternalApprovalTiersRow() {
  var section = document.querySelector('.lux-internal-approval-section')
  if (!section || section.querySelector('.lux-internal-approval-tiers-row')) return
  var tiersRow = document.createElement('div')
  tiersRow.className = 'lux-internal-approval-tiers-row'
  var title =
    section.querySelector('.lux-internal-approval-section-title-row') ||
    section.querySelector('.lux-internal-approval-section-title')
  var tierEls = section.querySelectorAll('.lux-internal-approval-tier')
  if (!tierEls.length) return
  if (title && title.nextSibling) {
    section.insertBefore(tiersRow, title.nextSibling)
  } else {
    section.appendChild(tiersRow)
  }
  tierEls.forEach(function (tier) {
    tiersRow.appendChild(tier)
  })
}

function ensureInternalApprovalPropertyWrapper(propertyCare) {
  if (!propertyCare) return null
  var wrapper = propertyCare.querySelector('.lux-internal-approval-settings')
  if (wrapper) {
    ensureInternalApprovalPropertyStyles()
    ensureLuxInternalApprovalSectionTitleMarkup()
    ensureInternalApprovalTiersRow()
    return wrapper
  }

  ensureInternalApprovalPropertyStyles()
  wrapper = document.createElement('div')
  wrapper.className = 'sub-section-content-row lux-internal-approval-settings'

  var section = document.createElement('div')
  section.className = 'lux-internal-approval-section'
  section.appendChild(createLuxInternalApprovalSectionTitleRow())

  var tiersRow = document.createElement('div')
  tiersRow.className = 'lux-internal-approval-tiers-row'
  section.appendChild(tiersRow)

  LUX_INTERNAL_APPROVAL_TIER_DEFS.forEach(function (tier) {
    var tierWrap = document.createElement('div')
    tierWrap.className = 'lux-internal-approval-tier lux-internal-approval-tier-' + tier.key
    if (tier.key === 'second') tierWrap.style.display = 'none'
    var body = document.createElement('div')
    body.className = 'lux-internal-approval-tier-body'
    body.style.display = tier.enable ? 'none' : 'flex'
    if (tier.title) {
      var heading = document.createElement('h4')
      heading.textContent = tier.title
      tierWrap.appendChild(heading)
    }
    tierWrap.appendChild(body)
    tiersRow.appendChild(tierWrap)
  })

  wrapper.appendChild(section)

  var insertBefore = luxInternalApprovalPropertyInsertBeforeRow(propertyCare)
  if (insertBefore) {
    propertyCare.insertBefore(wrapper, insertBefore)
  } else {
    propertyCare.appendChild(wrapper)
  }
  return wrapper
}

function luxPlaceInternalApprovalFieldInTier(wrapper, slot, col) {
  if (!wrapper || !col) return
  var tierWrap = wrapper.querySelector('.lux-internal-approval-tier-' + slot.tierKey)
  if (!tierWrap) return
  var body = tierWrap.querySelector('.lux-internal-approval-tier-body')
  // Section clicks rerun placement. Moving an already placed field drops focus.
  var target = slot.name === 'enable' ? tierWrap : (body || tierWrap)
  if (col.parentElement === target) return
  if (slot.name === 'enable') {
    col.style.minWidth = '100%'
    if (body) tierWrap.insertBefore(col, body)
    else tierWrap.appendChild(col)
    return
  }
  if (slot.name === 'limit' || slot.name === 'mode' || slot.name === 'contact') {
    col.classList.add('lux-approval-labeled-field')
    var label = col.querySelector('.ant-form-item-label label')
    var text = slot.name === 'limit' ? 'Betragsgrenze (€)' : slot.name === 'mode' ? 'Freigabe durch' : 'Vordefinierter Freigeber'
    if (label) { label.textContent = text; label.setAttribute('title', text) }
    var input = col.querySelector('.contact-combobox-search-input')
    if (input) input.setAttribute('aria-label', text)
  }
  if (body) body.appendChild(col)
  else tierWrap.appendChild(col)
}

function luxApprovalAmountDomainValue(fieldName) {
  var defaults = window.__luxPropertyApprovalDefaults || {}
  var limit = fieldName === 'proprety_first_internal_approval_amount_limit'
    ? defaults.secondAmountLimit : defaults.thirdAmountLimit
  return Number(limit || 0).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

/** Keep inheritance separate from the visible numeric value when saving. */
function luxApprovalAmountValueForSave(input) {
  return input.getAttribute('data-lux-inherit-approval-limit') === 'true' ? '' : input.value
}

function configureInternalApprovalAmountField(col, def) {
  var input = col.querySelector('.impowerx-currency-input')
  if (!input || col.querySelector('.lux-approval-limit-reset')) return
  if (def.inheritsApprovalAmountLimit) input.setAttribute('data-lux-inherit-approval-limit', 'true')
  input.setAttribute('aria-label', def.label)
  input.required = false
  input.addEventListener('input', function () {
    input.removeAttribute('data-lux-inherit-approval-limit')
    syncDisabled()
  })
  var reset = document.createElement('button')
  reset.type = 'button'
  reset.className = 'lux-approval-limit-reset'
  reset.textContent = 'zurücksetzen'
  reset.setAttribute('aria-label', (def.name === 'proprety_first_internal_approval_amount_limit' ? '2.' : '3.') + ' Freigabe: zurücksetzen auf Domainstandard')
  reset.title = 'Domainstandard: ' + luxApprovalAmountDomainValue(def.name) + ' €'
  reset.style.cssText = 'display:block;align-self:flex-start;text-align:left;margin:8px auto 0 0;border:0;background:none;padding:0;color:#1b243e;text-decoration:underline;font:inherit;cursor:pointer;'
  function syncDisabled() {
    reset.disabled = input.disabled || input.readOnly || input.getAttribute('data-lux-inherit-approval-limit') === 'true'
    reset.style.opacity = reset.disabled ? '0.5' : '1'
    reset.style.cursor = reset.disabled ? 'default' : 'pointer'
  }
  syncDisabled()
  new MutationObserver(syncDisabled).observe(input, { attributes: true, attributeFilter: ['disabled', 'readonly', 'data-lux-inherit-approval-limit'] })
  reset.addEventListener('click', function () {
    if (input.disabled || input.readOnly) return
    input.value = luxApprovalAmountDomainValue(def.name)
    input.setAttribute('data-lux-inherit-approval-limit', 'true')
    syncDisabled()
  })
  input.closest('.ant-form-item-control').appendChild(reset)
}

/**
 * Build Freigabe 2/3 into a grouped wrapper on first inject so they never
 * appear as generic 2-column ImpowerX rows (avoids flicker and leftover rows).
 */
function injectInternalApprovalPropertyFieldsGrouped(fieldDefs, options) {
  options = options || {}
  var propertyCare = document.querySelector('#PropertyCare .sub-section-content')
  if (!propertyCare || !fieldDefs || !fieldDefs.length) return false

  var generate = options.generateField
  var byName = {}
  fieldDefs.forEach(function (f) {
    if (f && f.name) byName[f.name] = f
  })

  var wrapper = ensureInternalApprovalPropertyWrapper(propertyCare)
  if (!wrapper) return false

  LUX_INTERNAL_APPROVAL_TIER_DEFS.forEach(function (tier) {
    ;['enable', 'limit', 'mode', 'contact', 'override', 'skip'].forEach(function (slotName) {
      var fieldName = tier[slotName]
      if (!fieldName) return
      var existing = document.getElementById(fieldName)
      if (existing && slotName === 'limit' && byName[fieldName]) configureInternalApprovalAmountField(existing, byName[fieldName])
      if (existing && wrapper.contains(existing)) return
      if (existing) {
        luxPlaceInternalApprovalFieldInTier(wrapper, { tierKey: tier.key, name: slotName }, existing)
        return
      }
      if (typeof generate !== 'function') return
      var def = byName[fieldName]
      if (!def) return
      var col = generate(def)
      if (!col) return
      if (slotName === 'limit') configureInternalApprovalAmountField(col, def)
      luxPlaceInternalApprovalFieldInTier(wrapper, { tierKey: tier.key, name: slotName }, col)
    })
  })

  luxPlaceExternalApprovalPropertyField(wrapper, propertyCare)
  luxRepositionInternalApprovalPropertyWrapper(propertyCare)
  if (typeof applyInternalApprovalPropertyVisibility === 'function') {
    applyInternalApprovalPropertyVisibility(options.visibilityHooks || {})
  }
  return true
}

function luxPlaceExternalApprovalPropertyField(wrapper, propertyCare) {
  var col = propertyCare.querySelector('#property_max_capex, #proprety_max_capex')
  if (!col) return
  var tier = wrapper.querySelector('.lux-internal-approval-tier-external')
  if (!tier) {
    tier = document.createElement('div')
    tier.className = 'lux-internal-approval-tier lux-internal-approval-tier-external'
    var body = document.createElement('div')
    body.className = 'lux-internal-approval-tier-body'
    tier.appendChild(body)
    wrapper.querySelector('.lux-internal-approval-tiers-row').appendChild(tier)
  }
  var toggle = col.querySelector('.lux-external-approval-enabled')
  if (toggle) tier.insertBefore(toggle.closest('label'), tier.firstChild)
  var oldRow = col.closest('.sub-section-content-row')
  luxPlaceInternalApprovalFieldInTier(wrapper, { tierKey: 'external', name: 'limit' }, col)
  if (oldRow && oldRow !== wrapper && !oldRow.querySelector('.ehv-element, input, select, button')) oldRow.remove()
  var skip = propertyCare.querySelector('#proprety_allow_skip_external_approval')
  if (skip) {
    var skipRow = skip.closest('.sub-section-content-row')
    luxPlaceInternalApprovalFieldInTier(wrapper, { tierKey: 'external', name: 'skip' }, skip)
    if (skipRow && skipRow !== wrapper && !skipRow.querySelector('.ehv-element, input, select, button')) skipRow.remove()
    configureExternalApprovalSkipField(tier, skip)
  }
  var enabled = tier.querySelector('.lux-external-approval-enabled')
  if (enabled) tier.querySelector('.lux-internal-approval-tier-body').style.display = enabled.checked ? 'flex' : 'none'
}

function configureExternalApprovalSkipField(tier, skip) {
  var group = skip.querySelector('.ant-checkbox-group')
  var input = skip.querySelector('input[type="checkbox"]')
  var enabled = tier.querySelector('.lux-external-approval-enabled')
  var amount = tier.querySelector('.impowerx-currency-input')
  var reset = tier.querySelector('.lux-external-approval-limit-reset')
  if (!group || !input || !enabled || !amount || !reset || group.getAttribute('data-lux-external-skip-ready')) return
  group.setAttribute('data-lux-external-skip-ready', 'true')
  var defaults = window.__luxPropertyApprovalDefaults || {}
  var saved = window.__luxPropertyExternalApprovalSkip
  function setChecked(checked) {
    input.checked = !!checked
    input.parentElement.classList.toggle('ant-checkbox-checked', input.checked)
  }
  if (saved == null || saved === 'inherit') {
    group.setAttribute('data-lux-external-skip-inherit', 'true')
    setChecked(defaults.externalAllowSkip)
  } else {
    setChecked(String(saved).split('|').includes('true'))
  }
  function sync() {
    if (!enabled.checked) setChecked(false)
    var disabled = !enabled.checked || amount.disabled || amount.readOnly
    if (input.disabled !== disabled) input.disabled = disabled
    input.parentElement.classList.toggle('ant-checkbox-disabled', disabled)
    input.closest('label').classList.toggle('ant-checkbox-wrapper-disabled', disabled)
    var event = document.createEvent('Event')
    event.initEvent('lux-external-skip-change', false, false)
    enabled.dispatchEvent(event)
  }
  enabled.addEventListener('change', function () {
    if (!enabled.checked) group.removeAttribute('data-lux-external-skip-inherit')
    sync()
  })
  input.addEventListener('change', function () {
    group.removeAttribute('data-lux-external-skip-inherit')
    sync()
  })
  reset.addEventListener('click', function () {
    if (amount.disabled || amount.readOnly) return
    group.setAttribute('data-lux-external-skip-inherit', 'true')
    setChecked(defaults.externalAllowSkip)
    sync()
  })
  new MutationObserver(sync).observe(amount, { attributes: true, attributeFilter: ['disabled', 'readonly'] })
  new MutationObserver(sync).observe(input, { attributes: true, attributeFilter: ['disabled'] })
  sync()
}

function reorganizeInternalApprovalPropertyDom() {
  var propertyCare = document.querySelector('#PropertyCare .sub-section-content')
  if (!propertyCare) return false
  var wrapper = propertyCare.querySelector('.lux-internal-approval-settings')
  if (!wrapper) return false
  ensureInternalApprovalPropertyStyles()
  ensureLuxInternalApprovalSectionTitleMarkup()
  ensureInternalApprovalTiersRow()
  luxRepositionInternalApprovalPropertyWrapper(propertyCare)
  return true
}

/** Clear legacy inline indents from older inject versions. */
function syncInternalApprovalTierBodyIndent() {
  document.querySelectorAll('.lux-internal-approval-tier-body').forEach(function (body) {
    body.style.marginLeft = ''
    body.style.width = ''
  })
}

function isLuxAntCheckboxGroupChecked(groupEl) {
  if (!groupEl) return false
  var root = groupEl.classList && groupEl.classList.contains('ant-checkbox-group')
    ? groupEl
    : groupEl.querySelector('.ant-checkbox-group') || groupEl
  var inputs = root.querySelectorAll('input[type="checkbox"]')
  for (var i = 0; i < inputs.length; i++) {
    var inp = inputs[i]
    if (inp.checked) return true
    var wrap = inp.parentElement
    if (wrap && wrap.classList.contains('ant-checkbox-checked')) return true
  }
  return false
}

function syncLuxCheckboxInputsFromVisual(groupEl) {
  if (!groupEl) return
  var root = groupEl.classList && groupEl.classList.contains('ant-checkbox-group')
    ? groupEl
    : groupEl.querySelector('.ant-checkbox-group') || groupEl
  root.querySelectorAll('input[type="checkbox"]').forEach(function (inp) {
    var wrap = inp.parentElement
    inp.checked = !!(wrap && wrap.classList.contains('ant-checkbox-checked'))
  })
}

function luxInternalApprovalEnableFieldByName(fieldName) {
  var byName = document.querySelector('[name="' + fieldName + '"]')
  if (byName) return byName
  var col = document.getElementById(fieldName)
  if (!col) return null
  return col.querySelector('.ant-checkbox-group') || col
}

function getInternalApprovalPropertyTierDom() {
  var firstEnable = luxInternalApprovalEnableFieldByName('proprety_enable_first_internal_approval')
  var secondEnable = luxInternalApprovalEnableFieldByName('proprety_enable_second_internal_approval')
  var firstMode = document.querySelector('[name="proprety_first_internal_approval_mode"]')
  var firstContact = document.querySelector('[name="proprety_preferred_first_approver_contact_id"]')
  var firstOverride = document.querySelector(
    '[name="proprety_allow_override_first_internal_approver"]'
  )
  var firstSkip = document.querySelector('[name="proprety_allow_skip_first_internal_approval"]')
  var secondMode = document.querySelector('[name="proprety_second_internal_approval_mode"]')
  var secondContact = document.querySelector('[name="proprety_preferred_second_approver_contact_id"]')
  var secondOverride = document.querySelector(
    '[name="proprety_allow_override_second_internal_approver"]'
  )
  var secondSkip = document.querySelector('[name="proprety_allow_skip_second_internal_approval"]')
  return {
    firstEnable: firstEnable,
    secondEnable: secondEnable,
    firstMode: firstMode,
    firstContact: firstContact,
    firstOverride: firstOverride,
    firstSkip: firstSkip,
    secondMode: secondMode,
    secondContact: secondContact,
    secondOverride: secondOverride,
    secondSkip: secondSkip,
    tierFirst: document.querySelector('.lux-internal-approval-tier-first'),
    tierSecond: document.querySelector('.lux-internal-approval-tier-second'),
    firstInnerCols: [
      fieldRootColumn(firstMode),
      fieldRootColumn(firstContact),
      firstOverride ? fieldRootColumn(firstOverride) : null,
      firstSkip ? fieldRootColumn(firstSkip) : null,
    ],
    secondEnableCol: fieldRootColumn(secondEnable),
    secondInnerCols: [
      fieldRootColumn(secondMode),
      fieldRootColumn(secondContact),
      secondOverride ? fieldRootColumn(secondOverride) : null,
      secondSkip ? fieldRootColumn(secondSkip) : null,
    ],
  }
}

function luxSetInternalApprovalColumnsVisible(cols, visible) {
  ;(cols || []).forEach(function (col) {
    if (col) col.style.display = visible ? '' : 'none'
  })
}

function luxTierHasPredefinedReviewer(contactField, modeField) {
  if (!contactField || !modeField) return false
  return !!luxReadContactFieldSelectedId(contactField)
}

function syncInternalApprovalReviewerOverrideVisibility() {
  var dom = getInternalApprovalPropertyTierDom()
  if (!dom.firstMode) return

  var firstHasReviewer = luxTierHasPredefinedReviewer(dom.firstContact, dom.firstMode)
  var firstOverrideCol = dom.firstOverride ? fieldRootColumn(dom.firstOverride) : null
  if (firstOverrideCol) {
    firstOverrideCol.style.display = firstHasReviewer ? '' : 'none'
    if (!firstHasReviewer) luxClearInternalApprovalEnableField(dom.firstOverride)
  }

  var secondHasReviewer = luxTierHasPredefinedReviewer(dom.secondContact, dom.secondMode)
  var secondOverrideCol = dom.secondOverride ? fieldRootColumn(dom.secondOverride) : null
  if (secondOverrideCol) {
    secondOverrideCol.style.display = secondHasReviewer ? '' : 'none'
    if (!secondHasReviewer) luxClearInternalApprovalEnableField(dom.secondOverride)
  }
}

function luxClearInternalApprovalEnableField(enableField) {
  if (!enableField) return
  var root = enableField.classList && enableField.classList.contains('ant-checkbox-group')
    ? enableField
    : enableField.querySelector('.ant-checkbox-group') || enableField
  root.querySelectorAll('input[type="checkbox"]').forEach(function (inp) {
    inp.checked = false
    inp.removeAttribute('checked')
    var wrap = inp.parentElement
    if (wrap && wrap.classList.contains('ant-radio-checked')) wrap.classList.remove('ant-radio-checked')
    if (wrap && wrap.classList.contains('ant-checkbox-checked')) wrap.classList.remove('ant-checkbox-checked')
  })
}

/**
 * Show/hide tier bodies from checkbox state (load, after save, toggle).
 * When a Freigabe tier is off, related contact / override / skip are cleared.
 * @param {{ reloadFirstContacts?: function, reloadSecondContacts?: function, resetFirstPreferred?: function, resetSecondPreferred?: function, resetSecondWhenFirstOff?: boolean }} [hooks]
 */
function applyInternalApprovalPropertyVisibility(hooks) {
  hooks = hooks || {}
  LUX_INTERNAL_APPROVAL_TIER_DEFS.forEach(function (tier) {
    var mode = document.querySelector('[name="' + tier.mode + '"]')
    luxSyncApprovalRoleDropdown(mode)
    if (mode && mode.__luxAssignmentWire) mode.__luxAssignmentWire.reloadContacts()
  })
  var dom = getInternalApprovalPropertyTierDom()
  if (!dom.firstEnable || !dom.tierFirst) return false

  syncLuxCheckboxInputsFromVisual(dom.firstEnable)
  syncLuxCheckboxInputsFromVisual(dom.secondEnable)

  var firstOn = isLuxAntCheckboxGroupChecked(dom.firstEnable)
  var secondOn = firstOn && isLuxAntCheckboxGroupChecked(dom.secondEnable)

  if (dom.tierFirst) {
    var firstBody = dom.tierFirst.querySelector('.lux-internal-approval-tier-body')
    if (firstBody) firstBody.style.display = firstOn ? '' : 'none'
  }
  luxSetInternalApprovalColumnsVisible(dom.firstInnerCols, firstOn)

  if (dom.tierSecond) dom.tierSecond.style.display = firstOn ? '' : 'none'
  luxSetInternalApprovalColumnsVisible([dom.secondEnableCol], firstOn)

  if (!firstOn) {
    luxClearInternalApprovalEnableField(dom.firstSkip)
    luxClearInternalApprovalEnableField(dom.firstOverride)
    resetInternalApprovalModeField(dom.firstMode)
    if (hooks.resetFirstPreferred) hooks.resetFirstPreferred()
    else resetPropertyContactField(dom.firstContact)

    if (hooks.resetSecondWhenFirstOff !== false) {
      luxClearInternalApprovalEnableField(dom.secondEnable)
      luxClearInternalApprovalEnableField(dom.secondSkip)
      luxClearInternalApprovalEnableField(dom.secondOverride)
      resetInternalApprovalModeField(dom.secondMode)
      if (hooks.resetSecondPreferred) hooks.resetSecondPreferred()
      else resetPropertyContactField(dom.secondContact)
    }
    if (dom.tierSecond) {
      var secondBodyOff = dom.tierSecond.querySelector('.lux-internal-approval-tier-body')
      if (secondBodyOff) secondBodyOff.style.display = 'none'
    }
    luxSetInternalApprovalColumnsVisible(dom.secondInnerCols, false)
  } else {
    if (dom.tierSecond) {
      var secondBody = dom.tierSecond.querySelector('.lux-internal-approval-tier-body')
      if (secondBody) secondBody.style.display = secondOn ? '' : 'none'
    }
    luxSetInternalApprovalColumnsVisible(dom.secondInnerCols, secondOn)
    if (!secondOn) {
      luxClearInternalApprovalEnableField(dom.secondSkip)
      luxClearInternalApprovalEnableField(dom.secondOverride)
      resetInternalApprovalModeField(dom.secondMode)
      if (hooks.resetSecondPreferred) hooks.resetSecondPreferred()
      else resetPropertyContactField(dom.secondContact)
    }
    if (firstOn && hooks.reloadFirstContacts) hooks.reloadFirstContacts()
    if (secondOn && hooks.reloadSecondContacts) hooks.reloadSecondContacts()
  }

  ensureInternalApprovalPropertyStyles()
  syncInternalApprovalTierBodyIndent()
  syncInternalApprovalReviewerOverrideVisibility()
  return true
}

function refreshInternalApprovalPropertyVisibility() {
  var propertyCareRoot = document.querySelector('#PropertyCare')
  var hooks = propertyCareRoot && propertyCareRoot.__luxInternalApprovalHooks
  return applyInternalApprovalPropertyVisibility(hooks || {})
}

function initInternalApprovalPropertyFields(propertyHrId, attempt) {
  initInternalApprovalPropertyUi(propertyHrId, attempt || 0)
}

/** @deprecated use initInternalApprovalPropertyFields */
function initSecondInternalApprovalPropertyFields(propertyHrId, attempt) {
  initInternalApprovalPropertyUi(propertyHrId, attempt || 0)
}

function initInternalApprovalPropertyUi(propertyHrId, attempt) {
  attempt = attempt || 0
  var firstEnable = luxInternalApprovalEnableFieldByName('proprety_enable_first_internal_approval')
  var firstMode = document.querySelector('[name="proprety_first_internal_approval_mode"]')
  var firstContact = document.querySelector('[name="proprety_preferred_first_approver_contact_id"]')
  var firstSkip = document.querySelector('[name="proprety_allow_skip_first_internal_approval"]')
  var secondEnable = luxInternalApprovalEnableFieldByName('proprety_enable_second_internal_approval')
  var secondMode = document.querySelector('[name="proprety_second_internal_approval_mode"]')
  var secondContact = document.querySelector('[name="proprety_preferred_second_approver_contact_id"]')
  var secondSkip = document.querySelector('[name="proprety_allow_skip_second_internal_approval"]')
  if (
    !firstEnable ||
    !firstMode ||
    !firstContact ||
    !secondEnable ||
    !secondMode ||
    !secondContact
  ) {
    if (attempt < 25) {
      setTimeout(function () {
        initInternalApprovalPropertyUi(propertyHrId, attempt + 1)
      }, 300)
    }
    return
  }
  var propertyCareRoot = document.querySelector('#PropertyCare')
  if (!propertyCareRoot) {
    if (attempt < 40) {
      setTimeout(function () {
        initInternalApprovalPropertyUi(propertyHrId, attempt + 1)
      }, 300)
    }
    return
  }

  if (!reorganizeInternalApprovalPropertyDom()) {
    if (attempt < 40) {
      setTimeout(function () {
        initInternalApprovalPropertyUi(propertyHrId, attempt + 1)
      }, 300)
    }
    return
  }

  ensureLuxInternalApprovalSectionTitleMarkup()
  ;['content', 'payment'].forEach(function (key) {
    var mode = document.querySelector('[name="proprety_' + key + '_approval_mode"]')
    var contact = document.querySelector('[name="proprety_' + key + '_approver_contact_id"]')
    if (!mode || !contact) return
    if (!mode.__luxAssignmentWire) {
      mode.__luxAssignmentWire = wireInternalApprovalPropertyTier({
        propertyHrId: propertyHrId, modeField: mode, contactField: contact,
        preferredFieldName: 'proprety_' + key + '_approver_contact_id', isActive: function () { return true },
      })
      configureInternalApprovalModeField(mode, mode.__luxAssignmentWire.onModeChange)
      mode.__luxAssignmentWire.bootstrap()
    } else mode.__luxAssignmentWire.reloadContacts()
  })

  ensureInternalApprovalPropertyStyles()
  syncInternalApprovalTierBodyIndent()
  requestAnimationFrame(syncInternalApprovalTierBodyIndent)

  var alreadyBound = propertyCareRoot.dataset.luxInternalApprovalPropertyUiBound === propertyHrId
  var dom = getInternalApprovalPropertyTierDom()

  function onFirstEnableChange() {
    var live = getInternalApprovalPropertyTierDom()
    var firstOn = isLuxAntCheckboxGroupChecked(live.firstEnable)
    var hooks = propertyCareRoot.__luxInternalApprovalHooks || {}
    if (!firstOn) {
      luxClearInternalApprovalEnableField(live.firstSkip)
      luxClearInternalApprovalEnableField(live.firstOverride)
      resetInternalApprovalModeField(live.firstMode)
      if (hooks.resetFirstPreferred) hooks.resetFirstPreferred()
      else resetPropertyContactField(live.firstContact)
      luxClearInternalApprovalEnableField(live.secondEnable)
      luxClearInternalApprovalEnableField(live.secondSkip)
      luxClearInternalApprovalEnableField(live.secondOverride)
      resetInternalApprovalModeField(live.secondMode)
      if (hooks.resetSecondPreferred) hooks.resetSecondPreferred()
      else resetPropertyContactField(live.secondContact)
    }
    applyInternalApprovalPropertyVisibility(hooks)
  }

  function onSecondEnableChange() {
    var live = getInternalApprovalPropertyTierDom()
    var hooks = propertyCareRoot.__luxInternalApprovalHooks || {}
    var firstOn = isLuxAntCheckboxGroupChecked(live.firstEnable)
    var secondOn = firstOn && isLuxAntCheckboxGroupChecked(live.secondEnable)
    if (!secondOn) {
      luxClearInternalApprovalEnableField(live.secondSkip)
      luxClearInternalApprovalEnableField(live.secondOverride)
      resetInternalApprovalModeField(live.secondMode)
      if (hooks.resetSecondPreferred) hooks.resetSecondPreferred()
      else resetPropertyContactField(live.secondContact)
    }
    applyInternalApprovalPropertyVisibility(hooks)
  }

  if (!alreadyBound) {
    propertyCareRoot.dataset.luxInternalApprovalPropertyUiBound = propertyHrId

    var wireFirstTier = wireInternalApprovalPropertyTier({
      propertyHrId: propertyHrId,
      modeField: dom.firstMode,
      contactField: dom.firstContact,
      preferredFieldName: 'proprety_preferred_first_approver_contact_id',
      isActive: function () {
        return isLuxAntCheckboxGroupChecked(
          luxInternalApprovalEnableFieldByName('proprety_enable_first_internal_approval')
        )
      },
    })
    var wireSecondTier = wireInternalApprovalPropertyTier({
      propertyHrId: propertyHrId,
      modeField: dom.secondMode,
      contactField: dom.secondContact,
      preferredFieldName: 'proprety_preferred_second_approver_contact_id',
      isActive: function () {
        return (
          isLuxAntCheckboxGroupChecked(
            luxInternalApprovalEnableFieldByName('proprety_enable_first_internal_approval')
          ) &&
          isLuxAntCheckboxGroupChecked(
            luxInternalApprovalEnableFieldByName('proprety_enable_second_internal_approval')
          )
        )
      },
    })

    propertyCareRoot.__luxInternalApprovalHooks = {
      reloadFirstContacts: function () {
        wireFirstTier.reloadContacts()
      },
      reloadSecondContacts: function () {
        wireSecondTier.reloadContacts()
      },
      resetFirstPreferred: function () {
        wireFirstTier.resetPreferredState()
      },
      resetSecondPreferred: function () {
        wireSecondTier.resetPreferredState()
      },
      onFirstModeChange: wireFirstTier.onModeChange,
      onSecondModeChange: wireSecondTier.onModeChange,
      resetSecondWhenFirstOff: true,
    }

    bindEnableFieldChange(dom.firstEnable, onFirstEnableChange)
    bindEnableFieldChange(dom.secondEnable, onSecondEnableChange)

    wireFirstTier.bootstrap()
    wireSecondTier.bootstrap()
  }

  var liveDom = getInternalApprovalPropertyTierDom()
  var hooks = propertyCareRoot.__luxInternalApprovalHooks
  if (hooks && liveDom.firstMode && hooks.onFirstModeChange) {
    configureInternalApprovalModeField(liveDom.firstMode, hooks.onFirstModeChange)
  }
  if (hooks && liveDom.secondMode && hooks.onSecondModeChange) {
    configureInternalApprovalModeField(liveDom.secondMode, hooks.onSecondModeChange)
  }

  applyInternalApprovalPropertyVisibility(propertyCareRoot.__luxInternalApprovalHooks)
  requestAnimationFrame(function () {
    applyInternalApprovalPropertyVisibility(propertyCareRoot.__luxInternalApprovalHooks)
    syncInternalApprovalTierBodyIndent()
  })

  if (window.__luxSecondApprovalPropertyEditWatch) {
    clearInterval(window.__luxSecondApprovalPropertyEditWatch)
  }
  var wasPropertyFormEditMode = luxIsPropertyFormEditMode()
  window.__luxSecondApprovalPropertyEditWatch = setInterval(function () {
    if (window.__luxImpowerxPropertyIsSaving) return
    var inEdit = luxIsPropertyFormEditMode()
    if (inEdit === wasPropertyFormEditMode) return
    wasPropertyFormEditMode = inEdit
    applyInternalApprovalPropertyVisibility(propertyCareRoot.__luxInternalApprovalHooks)
  }, 250)
}

function isAntRadioChecked(radioInput) {
  if (!radioInput) return false
  return (
    radioInput.checked ||
    (radioInput.parentElement &&
      radioInput.parentElement.classList.contains('ant-radio-checked'))
  )
}

function clearAntRadioGroup(modeField) {
  if (!modeField) return
  modeField.querySelectorAll('.ant-radio').forEach(function (span) {
    span.classList.remove('ant-radio-checked')
  })
  modeField.querySelectorAll('input[type="radio"]').forEach(function (inp) {
    inp.checked = false
  })
}

/** Unset property roles inherit the domain assignment. */
function getInternalApprovalModeFromField(modeField) {
  if (!modeField) return 'inherit'
  var radios = modeField.querySelectorAll('input[type="radio"]')
  for (var i = 0; i < radios.length; i++) {
    if (isAntRadioChecked(radios[i])) {
      return radios[i].value || 'inherit'
    }
  }
  return 'inherit'
}

/** Disabled tiers return to the domain assignment without creating a property override. */
function resetInternalApprovalModeField(modeField) {
  if (!modeField) return
  var radios = modeField.querySelectorAll('input[type="radio"]')
  var target = null
  for (var i = 0; i < radios.length; i++) {
    if (String(radios[i].value) === 'inherit') {
      target = radios[i]
      break
    }
  }
  if (target) syncAntRadioGroupSelection(modeField, target)
  else {
    clearAntRadioGroup(modeField)
    luxSyncApprovalRoleDropdown(modeField)
  }
}

function luxIsInternalApprovalModeDisplayLabel(label) {
  return LUX_INTERNAL_APPROVAL_MODE_RADIO_OPTIONS.some(function (option) { return option.label === String(label || '').trim() })
}
function luxInternalApprovalModeDisplayLabel(mode) {
  var option = LUX_INTERNAL_APPROVAL_MODE_RADIO_OPTIONS.find(function (option) { return option.value === mode })
  return option ? option.label : 'Domainstandard'
}
function luxInitialApprovalAssignment(fieldName) {
  return { mode: fieldName === 'proprety_content_approval_mode' ? 'property_supervisor' : fieldName === 'proprety_payment_approval_mode' ? 'property_accountant' : 'property_manager', contactId: null }
}
function luxEffectiveApprovalAssignment(fieldName, mode) {
  if (mode === 'inherit') return luxApprovalDomainAssignment(fieldName)
  return luxIsApprovalRoleAvailable(mode) ? { mode: mode, contactId: null } : luxInitialApprovalAssignment(fieldName)
}
function luxApprovalDomainAssignment(fieldName) {
  var settings = window.__luxPropertyApprovalDefaults || {}
  var fallback = luxInitialApprovalAssignment(fieldName)
  var prefix = fieldName === 'proprety_first_internal_approval_mode' ? 'second' : 'third'
  var assignment = fieldName === 'proprety_content_approval_mode' ? settings.contentAssignment : fieldName === 'proprety_payment_approval_mode' ? settings.paymentAssignment : { mode: settings[prefix + 'Mode'] || 'property_manager', contactId: settings[prefix + 'PreferredContactId'] || null }
  if (!assignment || !luxIsApprovalRoleAvailable(assignment.mode)) return fallback
  return assignment
}

/** Matches property-page edit/view state (`isInEditMode` + header fallback). */
function luxIsPropertyFormEditMode() {
  try {
    var stored = localStorage.getItem('isInEditMode')
    if (stored === 'true') return true
    if (stored === 'false') return false
  } catch (e) {}
  var saveLabels = [
    'speichern',
    'save',
    'save all',
    'save and continue',
    'speichern und weiter',
    'als entwurf speichern',
    'bereit zur verbuchung',
    'ready for invoice',
  ]
  var pageHeader =
    document.querySelector('.PageHeader[data-testid="page-header"]') ||
    document.querySelector('.PageHeader')
  var headerActionArea = (pageHeader && pageHeader.querySelector('.right-side')) || pageHeader
  if (headerActionArea) {
    var buttons = headerActionArea.querySelectorAll('button')
    for (var i = 0; i < buttons.length; i++) {
      var button = buttons[i]
      if (button.offsetParent === null || button.disabled) continue
      var label = (button.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase()
      if (saveLabels.indexOf(label) !== -1) return true
    }
  }
  return !!document.querySelector(
    '.ant-radio-input:not([disabled]), .ant-checkbox-input:not([disabled])'
  )
}

/**
 * @param {Element} contactField
 * @param {boolean} modeAllowsPicker - whether the picker is available
 * @param {string} mode
 */
function luxSetInternalApprovalContactFieldInteractive(contactField, modeAllowsPicker, mode) {
  if (!contactField) return
  var isAllMode = !modeAllowsPicker
  var interactive = !isAllMode && luxIsPropertyFormEditMode()
  var combobox = contactField.closest('.contact-combobox')
  var selectRoot =
    (combobox && combobox.querySelector('.impowerx-select')) ||
    contactField.closest('.impowerx-select') ||
    contactField.closest('.ant-select')
  var selectionItem = contactField.querySelector('.ant-select-selection-item')
  var searchInput = contactField.querySelector('.contact-combobox-search-input')
  var list = combobox ? combobox.querySelector('.contact-combobox-list') : null
  var modeLabel = luxInternalApprovalModeDisplayLabel(mode)

  if (selectRoot) {
    if (interactive) {
      selectRoot.classList.remove('read-only', 'ant-select-disabled', 'ContactComboDisable')
      selectRoot.removeAttribute('disabled')
    } else {
      selectRoot.classList.add('read-only', 'ant-select-disabled', 'ContactComboDisable')
      selectRoot.setAttribute('disabled', 'true')
    }
  }
  if (searchInput) {
    searchInput.disabled = !interactive
    if (interactive) searchInput.value = ''
    searchInput.style.visibility = 'visible'
    if (isAllMode || !interactive) {
      // Mode label (all) or locked view-mode selection — avoid overlapping placeholder.
      searchInput.setAttribute('placeholder', '')
    } else if (
      !selectionItem ||
      !String(selectionItem.textContent || '').trim() ||
      luxIsInternalApprovalModeDisplayLabel(selectionItem.textContent)
    ) {
      searchInput.setAttribute('placeholder', LUX_INTERNAL_APPROVAL_CONTACT_PLACEHOLDER)
    } else {
      searchInput.setAttribute('placeholder', '')
    }
  }
  var contactDropdown = combobox && combobox.querySelector('.lux-approval-contact-dropdown')
  if (contactDropdown) contactDropdown.disabled = !interactive || contactDropdown.dataset.loading === 'true'
  if (selectionItem) {
    if (isAllMode) {
      selectionItem.textContent = modeLabel
      selectionItem.setAttribute('title', modeLabel)
    } else if (luxIsInternalApprovalModeDisplayLabel(selectionItem.textContent)) {
      selectionItem.textContent = ''
      selectionItem.removeAttribute('title')
    }
  }
  if (isAllMode && list) {
    list.innerHTML = ''
  }
  luxSyncInternalApprovalContactClearBtn(contactField, {
    interactive: interactive,
    isAllMode: isAllMode,
  })
}

var LUX_INTERNAL_APPROVAL_CLEAR_BTN_HTML =
  '<span class="ant-select-clear impowerx-contact-combobox-clear" unselectable="on" style="user-select: none; display: none;">' +
  '<button type="button" class="impowerx-contact-combobox-clear-btn" tabindex="-1" aria-label="Auswahl entfernen" style="border:none;background:transparent;padding:0;margin:0;cursor:pointer;line-height:1;display:inline-flex;align-items:center;color:inherit;">' +
  '<span role="img" aria-label="close-circle" class="anticon anticon-close-circle">' +
  '<svg viewBox="64 64 896 896" focusable="false" data-icon="close-circle" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 01-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z"></path></svg>' +
  '</span></button></span>'

function luxEnsureInternalApprovalContactClearBtn(contactField) {
  if (!contactField) return null
  var selectRoot =
    contactField.closest('.impowerx-select') ||
    contactField.closest('.ant-select') ||
    contactField
  if (!selectRoot) return null
  selectRoot.classList.add('ant-select-allow-clear')
  var clearWrap = selectRoot.querySelector('.impowerx-contact-combobox-clear')
  if (!clearWrap) {
    selectRoot.insertAdjacentHTML('beforeend', LUX_INTERNAL_APPROVAL_CLEAR_BTN_HTML)
    clearWrap = selectRoot.querySelector('.impowerx-contact-combobox-clear')
  }
  return clearWrap
}

function luxSyncInternalApprovalContactClearBtn(contactField, opts) {
  opts = opts || {}
  var clearWrap = luxEnsureInternalApprovalContactClearBtn(contactField)
  if (!clearWrap) return
  var clearBtn = clearWrap.querySelector('.impowerx-contact-combobox-clear-btn')
  var hasSelection = !!luxReadContactFieldSelectedId(contactField)
  var interactive = opts.interactive != null ? !!opts.interactive : luxIsPropertyFormEditMode()
  var isAllMode = !!opts.isAllMode
  var show = hasSelection && interactive && !isAllMode
  clearWrap.style.display = show ? '' : 'none'
  var arrow = contactField.querySelector('.ant-select-arrow')
  if (arrow) arrow.style.display = show ? 'none' : ''
  if (clearBtn) {
    clearBtn.disabled = !show
    clearBtn.style.cursor = show ? 'pointer' : 'not-allowed'
    clearBtn.style.opacity = show ? '1' : '0.35'
  }
}

function luxNormalizeStoredContactId(raw) {
  if (raw == null) return ''
  var id = String(raw).trim()
  if (!id || id === '""' || id === "''" || id === 'null' || id === 'undefined') return ''
  if (!/^\d+$/.test(id)) return ''
  var n = parseInt(id, 10)
  if (!Number.isFinite(n) || n <= 0) return ''
  return String(n)
}

function luxSanitizeContactDisplayLabel(label) {
  if (label == null) return ''
  var t = String(label).trim()
  if (!t) return ''
  if (t === 'Kontakt ""' || t === "Kontakt ''") return ''
  if (/^Kontakt\s*(""|'')\s*$/i.test(t)) return ''
  if (luxIsInternalApprovalModeDisplayLabel(t)) return ''
  return t
}

function luxPendingPreferredContactLabel(contactId) {
  var id = luxNormalizeStoredContactId(contactId)
  return id ? 'Kontakte-' + id : ''
}

function luxContactLabelFromDom(contactId) {
  var id = luxNormalizeStoredContactId(contactId)
  if (!id) return ''
  var items = document.querySelectorAll('.contact-combobox-item[data-value]')
  for (var i = 0; i < items.length; i++) {
    if (String(items[i].getAttribute('data-value')) !== id) continue
    var labelEl = items[i].querySelector('.select-menu-item')
    if (labelEl && labelEl.textContent) return labelEl.textContent.trim()
  }
  return ''
}

function luxReadContactFieldSelectedId(contactField) {
  if (!contactField) return ''
  if (typeof $ !== 'undefined') {
    var fromJq = $(contactField).data('selected-value')
    var fromJqNorm = luxNormalizeStoredContactId(fromJq)
    if (fromJqNorm) return fromJqNorm
  }
  var fromAttr = luxNormalizeStoredContactId(contactField.getAttribute('data-selected-value'))
  if (fromAttr) return fromAttr
  var selectedOption = contactField
    .closest('.contact-combobox')
    ?.querySelector('.contact-combobox-item.ant-select-item-option-selected')
  if (selectedOption) {
    return luxNormalizeStoredContactId(selectedOption.getAttribute('data-value'))
  }
  return ''
}

function luxIsApprovalRoleAvailable(mode) {
  var available = window.__luxPropertyApprovalRoleAvailability || {}
  if (mode === 'case_worker' || mode === 'primary_case_worker') return !!available[mode]
  return available[mode] !== false
}

// Keep legacy radio values for the property serializer; present one compact dropdown.
function luxSyncApprovalRoleDropdown(modeField) {
  if (!modeField) return
  var select = modeField.querySelector('.lux-approval-role-dropdown')
  if (!select) return
  var storedMode = getInternalApprovalModeFromField(modeField)
  var defaults = luxApprovalDomainAssignment(modeField.getAttribute('name'))
  var effectiveMode = luxEffectiveApprovalAssignment(modeField.getAttribute('name'), storedMode).mode
  if (!Array.prototype.some.call(select.options, function (o) { return o.value === effectiveMode })) {
    var missing = document.createElement('option')
    missing.value = effectiveMode
    var legacy = effectiveMode === 'user' || effectiveMode === 'all'
    missing.hidden = legacy
    missing.disabled = legacy || !luxIsApprovalRoleAvailable(effectiveMode)
    missing.textContent = luxInternalApprovalModeDisplayLabel(effectiveMode) + (legacy ? ' (bestehende Einstellung)' : missing.disabled ? ' (nicht am Objekt zugewiesen)' : '')
    select.appendChild(missing)
  }
  var inheritOption = select.querySelector('option[value="inherit"]')
  if (inheritOption) {
    inheritOption.disabled = !luxIsApprovalRoleAvailable(defaults.mode)
    inheritOption.textContent = 'Domainstandard verwenden (' + luxInternalApprovalModeDisplayLabel(defaults.mode) + ')'
  }
  select.value = effectiveMode
  select.disabled = !luxIsPropertyFormEditMode()
}

function luxEnsureApprovalRoleDropdown(modeField, onModeChange) {
  if (!modeField) return
  var select = modeField.querySelector('.lux-approval-role-dropdown')
  if (!select) {
    select = document.createElement('select')
    select.className = 'lux-approval-role-dropdown'
    select.setAttribute('aria-label', 'Freigabe durch')
    modeField.querySelectorAll('input[type="radio"]').forEach(function (radio) {
      if (radio.value === 'user' || radio.value === 'all') return
      if (!luxIsApprovalRoleAvailable(radio.value)) return
      var option = document.createElement('option')
      option.value = radio.value
      option.textContent = luxInternalApprovalModeDisplayLabel(radio.value)
      select.appendChild(option)
    })
    select.addEventListener('change', function () {
      var radio = modeField.querySelector('input[value="' + select.value + '"]')
      if (radio) syncAntRadioGroupSelection(modeField, radio)
      if (onModeChange) onModeChange()
    })
    modeField.appendChild(select)
    modeField.classList.add('lux-approval-has-dropdown')
  }
  luxSyncApprovalRoleDropdown(modeField)
}

function configureInternalApprovalModeField(modeField, onModeChange) {
  luxEnsureApprovalRoleDropdown(modeField, onModeChange)
  if (!modeField || modeField.dataset.luxInternalApprovalModeWired === '1') return
  modeField.dataset.luxInternalApprovalModeWired = '1'

  function applyModeFromRadioInput(input) {
    if (!input || !modeField.contains(input)) return
    syncAntRadioGroupSelection(modeField, input)
    if (onModeChange) onModeChange()
  }

  modeField.addEventListener(
    'click',
    function (e) {
      var input = findInternalApprovalModeRadioFromEvent(modeField, e)
      if (input) applyModeFromRadioInput(input)
    },
    true
  )
  modeField.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) {
      applyModeFromRadioInput(e.target)
    }
  })
}

function syncAntRadioGroupSelection(modeField, selectedInput) {
  if (!modeField || !selectedInput) return
  clearAntRadioGroup(modeField)
  selectedInput.checked = true
  if (selectedInput.parentElement) {
    selectedInput.parentElement.classList.add('ant-radio-checked')
  }
  luxSyncApprovalRoleDropdown(modeField)
}

function findInternalApprovalModeRadioFromEvent(modeField, e) {
  if (!modeField || !e || !e.target) return null
  if (e.target.matches && e.target.matches('input[type="radio"]') && modeField.contains(e.target)) {
    return e.target
  }
  var optionRoot =
    e.target.closest &&
    e.target.closest('.radio-group-option, .ant-radio-wrapper, label')
  if (!optionRoot || !modeField.contains(optionRoot)) return null
  return optionRoot.querySelector('input[type="radio"]')
}

function wireInternalApprovalPropertyTier(config) {
  var preferredByMode = {}
  var lastMode = null
  var savedPreferredFromApi = ''
  var suppressPreferredRestore = false
  config.modeFieldName =
    config.modeFieldName ||
    (config.modeField && config.modeField.getAttribute('name')) ||
    ''
  config.contactFieldName =
    config.contactFieldName ||
    (config.contactField && config.contactField.getAttribute('name')) ||
    ''

  function resolveModeField() {
    if (config.modeFieldName) {
      var liveMode = document.querySelector('[name="' + config.modeFieldName + '"]')
      if (liveMode) return liveMode
    }
    return config.modeField
  }

  function resolveContactField() {
    if (config.contactFieldName) {
      var liveContact = document.querySelector('[name="' + config.contactFieldName + '"]')
      if (liveContact) return liveContact
    }
    return config.contactField
  }

  fetchPropertyImpowerField(config.propertyHrId, config.preferredFieldName).then(function (v) {
    if (suppressPreferredRestore) return
    if (v) savedPreferredFromApi = v
    else if (!savedPreferredFromApi) {
      savedPreferredFromApi = luxReadContactFieldSelectedId(resolveContactField())
    }
    if (getSelectedMode() && getCurrentPreferredValue()) {
      preferredByMode[getSelectedMode()] = getCurrentPreferredValue()
    }
    if (config.isActive()) reloadContacts()
  })

  function getSelectedMode() {
    return getInternalApprovalModeFromField(resolveModeField())
  }

  function getCurrentPreferredValue() {
    var fromDom = luxReadContactFieldSelectedId(resolveContactField())
    if (fromDom) return fromDom
    return savedPreferredFromApi || ''
  }

  function setPreferredStoredValue(selectedId) {
    var contactField = resolveContactField()
    if (!contactField) return
    var normalized = luxNormalizeStoredContactId(selectedId)
    if (normalized) {
      contactField.setAttribute('data-selected-value', normalized)
      if (typeof $ !== 'undefined') $(contactField).data('selected-value', normalized)
      return
    }
    // Preserve explicit clear sentinel ('0') so save persists the deletion.
    var currentAttr = contactField.getAttribute('data-selected-value')
    var currentData =
      typeof $ !== 'undefined' ? String($(contactField).data('selected-value') || '') : ''
    if (
      currentAttr === LUX_CLEARED_PREFERRED_APPROVER_CONTACT ||
      currentData === LUX_CLEARED_PREFERRED_APPROVER_CONTACT
    ) {
      contactField.setAttribute(
        'data-selected-value',
        LUX_CLEARED_PREFERRED_APPROVER_CONTACT
      )
      if (typeof $ !== 'undefined') {
        $(contactField).data('selected-value', LUX_CLEARED_PREFERRED_APPROVER_CONTACT)
      }
      return
    }
    contactField.removeAttribute('data-selected-value')
    if (typeof $ !== 'undefined') $(contactField).data('selected-value', '')
  }

  function markPreferredContactCleared() {
    var contactField = resolveContactField()
    if (!contactField) return
    contactField.setAttribute('data-selected-value', LUX_CLEARED_PREFERRED_APPROVER_CONTACT)
    if (typeof $ !== 'undefined') {
      $(contactField).data('selected-value', LUX_CLEARED_PREFERRED_APPROVER_CONTACT)
    }
  }

  // Use the same native dropdown as the role picker. Keep the existing field
  // as the serialization backing store, without depending on document-level
  // ContactComboBox click handlers to commit the selected contact.
  function syncContactDropdown(contacts, selectedId) {
    var contactField = resolveContactField()
    var combobox = contactField && contactField.closest('.contact-combobox')
    if (!combobox) return
    combobox.classList.add('lux-approval-native-contact')
    var select = combobox.querySelector('.lux-approval-contact-dropdown')
    if (!select) {
      select = document.createElement('select')
      select.className = 'lux-approval-role-dropdown lux-approval-contact-dropdown'
      select.setAttribute('aria-label', 'Vordefinierter Freigeber')
      select.addEventListener('click', function (event) { event.stopPropagation() })
      select.addEventListener('change', function (event) {
        event.stopPropagation()
        // An older options request must not replace the user's selection.
        loadRevision++
        if (!select.value) {
          clearPreferredContact()
          return
        }
        setPreferredStoredValue(select.value)
        var item = resolveContactField().querySelector('.ant-select-selection-item')
        if (item) {
          item.textContent = select.options[select.selectedIndex].textContent
          item.setAttribute('title', item.textContent)
        }
        onContactOptionSelected()
        luxSyncApprovalRoleDropdown(resolveModeField())
      })
      combobox.appendChild(select)
    }
    var mode = luxEffectiveApprovalAssignment(config.modeFieldName, getSelectedMode()).mode
    var followsProperty = mode === 'property_supervisor' || mode === 'property_accountant'
    select.dataset.approvalMode = mode
    select.dataset.loading = 'false'
    select.replaceChildren()
    var empty = document.createElement('option')
    empty.value = ''
    empty.textContent = mode === 'user' ? LUX_INTERNAL_APPROVAL_CONTACT_PLACEHOLDER
      : 'Alle Personen: ' + luxInternalApprovalModeDisplayLabel(mode)
    if (followsProperty) empty.textContent = 'Kein ' + luxInternalApprovalModeDisplayLabel(mode) + ' am Objekt hinterlegt'
    if (!followsProperty || !(contacts || []).length) select.appendChild(empty)
    ;(contacts || []).forEach(function (contact) {
      var option = document.createElement('option')
      option.value = String(contact.id)
      option.textContent = contact.name
      select.appendChild(option)
    })
    var id = followsProperty ? String((contacts || [])[0]?.id || '') : luxNormalizeStoredContactId(selectedId)
    if (id && !(contacts || []).some(function (contact) { return String(contact.id) === id })) {
      var unavailable = document.createElement('option')
      unavailable.value = id
      unavailable.textContent = 'Gespeicherter Freigeber nicht in dieser Rolle verfügbar'
      unavailable.disabled = true
      select.appendChild(unavailable)
    }
    select.value = id
    select.disabled = !luxIsPropertyFormEditMode()
  }

  function rebuildContactOptions(contacts, selectedId) {
    var contactField = resolveContactField()
    if (!contactField) return
    var combobox = contactField.closest('.contact-combobox')
    var list = combobox ? combobox.querySelector('.contact-combobox-list') : null
    if (!list) return
    var selectionItem = contactField.querySelector('.ant-select-selection-item')
    var preservedLabel = luxSanitizeContactDisplayLabel(
      selectionItem ? selectionItem.textContent : ''
    )
    var normalizedId = luxNormalizeStoredContactId(selectedId)
    var listContacts = (contacts || []).slice()
    list.innerHTML = ''
    listContacts.forEach(function (c) {
      var item = document.createElement('div')
      var isSelected = normalizedId && String(c.id) === normalizedId
      item.className =
        'ant-select-item ant-select-item-option contact-combobox-item' +
        (isSelected ? ' ant-select-item-option-selected' : '')
      item.setAttribute('data-value', String(c.id))
      item.setAttribute('title', c.name)
      item.innerHTML =
        '<div class="ant-select-item-option-content"><div class="select-menu-item">' +
        '</div></div>'
      item.querySelector('.select-menu-item').textContent = c.name
      list.appendChild(item)
    })
    setPreferredStoredValue(normalizedId)
    var sel = listContacts.find(function (c) {
      return String(c.id) === normalizedId
    })
    if (selectionItem) {
      var displayName = ''
      if (normalizedId) {
        displayName =
          luxSanitizeContactDisplayLabel(sel ? sel.name : preservedLabel) ||
          luxPendingPreferredContactLabel(normalizedId)
      }
      selectionItem.textContent = displayName
      selectionItem.setAttribute('title', displayName)
    }
    var searchInput = contactField.querySelector('.contact-combobox-search-input')
    if (searchInput) {
      searchInput.style.visibility = 'visible'
      if (normalizedId) {
        searchInput.setAttribute('placeholder', '')
      } else {
        searchInput.value = ''
        searchInput.setAttribute('placeholder', LUX_INTERNAL_APPROVAL_CONTACT_PLACEHOLDER)
      }
    }
    if (typeof syncInternalApprovalReviewerOverrideVisibility === 'function') {
      syncInternalApprovalReviewerOverrideVisibility()
    }
    luxSyncInternalApprovalContactClearBtn(contactField, {
      interactive: luxIsPropertyFormEditMode(),
      isAllMode: false,
    })
    syncContactDropdown(listContacts, normalizedId)
  }

  function clearPreferredContact(e) {
    if (e) {
      e.preventDefault()
      e.stopPropagation()
    }
    if (!luxIsPropertyFormEditMode()) return
    var mode = getSelectedMode()
    if (mode === 'inherit' || !luxIsApprovalRoleAvailable(mode)) mode = makeEffectiveRoleExplicit()
    if (mode) preferredByMode[mode] = ''
    savedPreferredFromApi = ''
    suppressPreferredRestore = true
    markPreferredContactCleared()
    var contactField = resolveContactField()
    if (!contactField) return
    var selectionItem = contactField.querySelector('.ant-select-selection-item')
    if (selectionItem) {
      selectionItem.textContent = ''
      selectionItem.removeAttribute('title')
    }
    var searchInput = contactField.querySelector('.contact-combobox-search-input')
    if (searchInput) {
      searchInput.value = ''
      searchInput.style.visibility = 'visible'
      searchInput.setAttribute('placeholder', LUX_INTERNAL_APPROVAL_CONTACT_PLACEHOLDER)
    }
    var combobox = contactField.closest('.contact-combobox')
    var list = combobox ? combobox.querySelector('.contact-combobox-list') : null
    if (list) {
      list.querySelectorAll('.contact-combobox-item.ant-select-item-option-selected').forEach(
        function (el) {
          el.classList.remove('ant-select-item-option-selected')
        }
      )
    }
    if (combobox) {
      var dropdown = combobox.querySelector('.impowerx-select-dropdown')
      if (dropdown) dropdown.classList.add('ant-select-dropdown-hidden')
    }
    if (typeof syncInternalApprovalReviewerOverrideVisibility === 'function') {
      syncInternalApprovalReviewerOverrideVisibility()
    }
    luxSyncInternalApprovalContactClearBtn(contactField, {
      interactive: true,
      isAllMode: false,
    })
    if (mode === 'user') {
      var inheritRadio = resolveModeField().querySelector('input[value="inherit"]')
      if (inheritRadio) syncAntRadioGroupSelection(resolveModeField(), inheritRadio)
      lastMode = 'inherit'
    }
    reloadContacts()
  }

  function ensureClearButtonWired() {
    var contactField = resolveContactField()
    var clearWrap = luxEnsureInternalApprovalContactClearBtn(contactField)
    if (!clearWrap || clearWrap.dataset.luxInternalApprovalClearWired === '1') {
      luxSyncInternalApprovalContactClearBtn(contactField, {
        interactive: luxIsPropertyFormEditMode(),
        isAllMode: false,
      })
      return
    }
    clearWrap.dataset.luxInternalApprovalClearWired = '1'
    var clearBtn = clearWrap.querySelector('.impowerx-contact-combobox-clear-btn')
    if (clearBtn) {
      clearBtn.addEventListener('mousedown', function (e) {
        e.preventDefault()
        e.stopPropagation()
      })
      clearBtn.addEventListener('click', clearPreferredContact)
    }
    luxSyncInternalApprovalContactClearBtn(contactField, {
      interactive: luxIsPropertyFormEditMode(),
      isAllMode: false,
    })
  }

  function onContactOptionSelected() {
    var mode = getSelectedMode()
    var selectedId = luxReadContactFieldSelectedId(resolveContactField())
    if (mode === 'inherit' || !luxIsApprovalRoleAvailable(mode)) mode = makeEffectiveRoleExplicit()
    if (mode) {
      preferredByMode[mode] = selectedId || ''
      if (selectedId) {
        savedPreferredFromApi = selectedId
        suppressPreferredRestore = false
      } else {
        savedPreferredFromApi = ''
        suppressPreferredRestore = true
      }
    }
    luxSyncInternalApprovalContactClearBtn(resolveContactField(), {
      interactive: luxIsPropertyFormEditMode(),
      isAllMode: false,
    })
    if (typeof syncInternalApprovalReviewerOverrideVisibility === 'function') {
      syncInternalApprovalReviewerOverrideVisibility()
    }
  }

  function makeEffectiveRoleExplicit() {
    var mode = luxEffectiveApprovalAssignment(config.modeFieldName, getSelectedMode()).mode
    var radio = resolveModeField().querySelector('input[value="' + mode + '"]')
    if (radio) syncAntRadioGroupSelection(resolveModeField(), radio)
    lastMode = mode
    return mode
  }

  var loadRevision = 0
  function reloadContacts() {
    var revision = ++loadRevision
    var mode = getSelectedMode()
    var inherited = mode === 'inherit'
    var assignment = luxEffectiveApprovalAssignment(config.modeFieldName, mode)
    var fallbackActive = !inherited && !luxIsApprovalRoleAvailable(mode)
    var originalPreferredValue = getCurrentPreferredValue()
    luxSetInternalApprovalContactFieldInteractive(resolveContactField(), true, assignment.mode)
    ensureClearButtonWired()
    if (!config.isActive()) return
    var contactBox = resolveContactField().closest('.contact-combobox')
    var dropdown = contactBox && contactBox.querySelector('.lux-approval-contact-dropdown')
    if (!dropdown || dropdown.dataset.approvalMode !== assignment.mode) {
      syncContactDropdown([], '')
      dropdown = contactBox && contactBox.querySelector('.lux-approval-contact-dropdown')
      if (dropdown) {
        dropdown.options[0].textContent = 'Freigeber werden geladen…'
        dropdown.dataset.loading = 'true'
        dropdown.disabled = true
      }
    }
    fetchInternalApprovalContactOptions(assignment.mode, config.propertyHrId).then(function (contacts) {
      if (revision !== loadRevision || mode !== getSelectedMode()) return
      var restoreId = inherited ? String(assignment.contactId || '')
        : suppressPreferredRestore ? '' : preferredByMode[mode] || savedPreferredFromApi || ''
      var followsProperty = assignment.mode === 'property_supervisor' || assignment.mode === 'property_accountant'
      if (followsProperty || fallbackActive) restoreId = ''
      rebuildContactOptions(contacts, restoreId)
      if (fallbackActive) setPreferredStoredValue(originalPreferredValue)
      else if (followsProperty) markPreferredContactCleared()
      luxSetInternalApprovalContactFieldInteractive(resolveContactField(), true, assignment.mode)
      ensureClearButtonWired()
      if (!restoreId && assignment.mode !== 'user') {
        var input = resolveContactField().querySelector('.contact-combobox-search-input')
        var poolLabel = 'Alle Personen: ' + luxInternalApprovalModeDisplayLabel(assignment.mode)
        if (input) input.setAttribute('placeholder', luxIsPropertyFormEditMode() ? poolLabel : '')
        if (!luxIsPropertyFormEditMode()) {
          var item = resolveContactField().querySelector('.ant-select-selection-item')
          if (item) { item.textContent = poolLabel; item.setAttribute('title', poolLabel) }
        }
      }
    }).catch(function (error) {
      if (revision !== loadRevision || mode !== getSelectedMode()) return
      if (dropdown && dropdown.disabled && dropdown.options[0]) {
        dropdown.options[0].textContent = 'Freigeber konnten nicht geladen werden'
      }
      console.error(error)
    })
  }

  function onModeChange() {
    if (!config.isActive()) return
    var mode = getSelectedMode()
    // Any mode switch drops the preselected contact because lists differ per role.
    if (lastMode && lastMode !== mode) {
      preferredByMode = {}
      savedPreferredFromApi = ''
      suppressPreferredRestore = true
      markPreferredContactCleared()
      var contactField = resolveContactField()
      var selectionItem =
        contactField && contactField.querySelector('.ant-select-selection-item')
      if (selectionItem) {
        selectionItem.textContent = ''
        selectionItem.removeAttribute('title')
      }
      if (typeof syncInternalApprovalReviewerOverrideVisibility === 'function') {
        syncInternalApprovalReviewerOverrideVisibility()
      }
    }
    lastMode = mode
    reloadContacts()
  }

  ensureClearButtonWired()
  var contactFieldForSelect = resolveContactField()
  var comboboxForSelect = contactFieldForSelect && contactFieldForSelect.closest('.contact-combobox')
  if (comboboxForSelect && comboboxForSelect.dataset.luxInternalApprovalSelectWired !== '1') {
    comboboxForSelect.dataset.luxInternalApprovalSelectWired = '1'
    comboboxForSelect.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.contact-combobox-item')) {
        setTimeout(onContactOptionSelected, 0)
      }
    })
  }

  return {
    bootstrap: function () {
      lastMode = getSelectedMode()
      var contactField = resolveContactField()
      var initialId = luxReadContactFieldSelectedId(contactField)
      if (initialId && !savedPreferredFromApi) savedPreferredFromApi = initialId
      if (initialId && contactField) {
        var selectionItem = contactField.querySelector('.ant-select-selection-item')
        var currentLabel = luxSanitizeContactDisplayLabel(
          selectionItem ? selectionItem.textContent : ''
        )
        if (selectionItem && !currentLabel) {
          var pending = luxPendingPreferredContactLabel(initialId)
          selectionItem.textContent = pending
          selectionItem.setAttribute('title', pending)
        }
      }
      ensureClearButtonWired()
      reloadContacts()
    },
    reloadContacts: reloadContacts,
    onModeChange: onModeChange,
    resetPreferredState: function () {
      preferredByMode = {}
      savedPreferredFromApi = ''
      suppressPreferredRestore = true
      lastMode = 'inherit'
      loadRevision++
      resetPropertyContactField(resolveContactField())
    },
  }
}

function fetchPropertyImpowerField(propertyHrId, fieldName) {
  return getImpowerXData(
    baseApiUrl + '/api/impowerX/properties?propertyHrId=' + encodeURIComponent(propertyHrId)
  )
    .then(function (p) {
      var fields = Array.isArray(p.fields) ? p.fields : []
      var prefField = fields.find(function (f) {
        return f.name === fieldName
      })
      if (prefField && prefField.value != null && prefField.value !== '') {
        return luxNormalizeStoredContactId(prefField.value)
      }
      return ''
    })
    .catch(function () {
      return ''
    })
}

function fieldRootColumn(el) {
  if (!el) return null
  return el.closest('.ehv-element') || el.closest('.sub-section-content-column')
}

function bindEnableFieldChange(enableField, handler) {
  if (!enableField) return
  enableField.querySelectorAll('input').forEach(function (inp) {
    inp.addEventListener('change', handler)
  })
  enableField.addEventListener('click', function (e) {
    if (e.target && e.target.matches('input')) setTimeout(handler, 0)
  })
}

function resetPropertyContactField(contactField) {
  if (!contactField) return
  // Persist clear via API sentinel (same as manual × clear).
  contactField.setAttribute('data-selected-value', LUX_CLEARED_PREFERRED_APPROVER_CONTACT)
  if (typeof $ !== 'undefined') {
    $(contactField).data('selected-value', LUX_CLEARED_PREFERRED_APPROVER_CONTACT)
  }
  var selectionItem = contactField.querySelector('.ant-select-selection-item')
  if (selectionItem) {
    selectionItem.textContent = ''
    selectionItem.removeAttribute('title')
  }
  var searchInput = contactField.querySelector('.contact-combobox-search-input')
  if (searchInput) {
    searchInput.value = ''
    searchInput.style.visibility = 'visible'
    searchInput.setAttribute('placeholder', LUX_INTERNAL_APPROVAL_CONTACT_PLACEHOLDER)
  }
  var combobox = contactField.closest('.contact-combobox')
  if (combobox) {
    combobox.querySelectorAll('.contact-combobox-item.ant-select-item-option-selected').forEach(
      function (el) {
        el.classList.remove('ant-select-item-option-selected')
      }
    )
    var dropdown = combobox.querySelector('.contact-combobox-list')
    if (dropdown) dropdown.innerHTML = ''
  }
  if (typeof luxSyncInternalApprovalContactClearBtn === 'function') {
    luxSyncInternalApprovalContactClearBtn(contactField, {
      interactive: false,
      isAllMode: false,
    })
  }
}

function initFirstInternalApprovalPropertyFields(propertyHrId, attempt) {
  initInternalApprovalPropertyUi(propertyHrId, attempt || 0)
}
